import Phaser, { Display } from 'phaser'
import { io } from "socket.io-client";

import $ from "jquery";
import DialogManager from "./DialogManager";
import dialogEvents from "./DialogManager/EventCenter";
import './Inventory.js'
//import './Livekit.js'
const socketPort = `https://xelestech.com/`;
const externalHost = `https://xelestech.com/`
//const socketPort = `${window.location.hostname}:3000/`;
//const externalHost = `http://${window.location.hostname}:3000/`

const category1 = 0b0001
const category2 = 0b0010
const category3 = 0b0100
const category4 = 0b1000

let fpsValue;
let uiFPS;
let uiPing;
let startTime;
let uiRoomSelected;
let selectedRoom;
let selectedRoomName;
const ROOM_LIMIT = 15;
//public chat
let form = document.getElementById('form');
let input = document.getElementById('input');
let publicChatHistory = document.getElementById('ui--public-chat__history');

//multiplayers
let playerStates = {};
let otherPlayerModels = {};
let mySelfPlayerModels = {};
let elementBubbleChat;
let socket;
let userName = "user" + getRandomNumberBetween(1, 10)
let elementBubbleChatArray = [];
let keys;

let building;
let playerLocal;
let playerLocalFur
let playerLocalVFX
let playerX = 6200;
let playerY = 5200;
let playerPaddingY = 300;
let playerPaddingX = -100;
let playerSpeed = 3;
let playerScale = 0.5;
let offX = 450
let offY = 480
let elementChracterName;
let player;
let animState = 'Idle';
let lastAnimState = 'Idle'
let musicOn = true
let musicAlreadyOn = false
let i_cloth = 1
let npcChief
let npcKnight
let npcFarmer
let attributeListConv = {}
let equipList 
let visualItemList
let visualItemInventory


function replacer(key, value) {
    if(value instanceof Map) {
      return {
        dataType: 'Map',
        value: Array.from(value.entries()), // or with spread: value: [...value]
      };
    } else {
      return value;
    }
  }

  function reviver(key, value) {
    if(typeof value === 'object' && value !== null) {
      if (value.dataType === 'Map') {
        return new Map(value.value);
      }
    }
    return value;
  }

function canvasEvent() {
    document.activeElement.blur();
}

function getRandomNumberBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function setSkin(player, skinName) {
    try {
        player.setSkinByName(skinName)
    } catch {
        console.log("cannot find attachment " + skinName)
    }
}

function SetAttachment(playerLocal, slotName, attachmentName) {
    try {
        playerLocal.skeleton.setAttachment(slotName, attachmentName)
    } catch {
        console.log("cannot find attachment " + attachmentName + " for slot " + slotName)
    }
}

function Equip(item,itemAttribute,player,playerFur,wearingList){
    updateWearingList(true,item,itemAttribute,wearingList)
    setAttachmentFull(player,playerFur,wearingList)
    //updateInventory(true,item,itemAttribute,visualItemInventory)
}

function UnEquip(item,itemAttribute,player,playerFur,wearingList){
    updateWearingList(false,item,itemAttribute,wearingList)
    setAttachmentFull(player,playerFur,wearingList)
    //updateInventory(false,item,itemAttribute,visualItemInventory)
}

function removeItemOnce(arr, value) {
    const index = arr.findIndex(object => {
        return object.name === value.name && object.partner === value.partner;
      });
    if (index > -1) {
      arr.splice(index, 1);
      return arr;
    }else{
      throw 'Parameter is not a number!';
      //return arr
    }
    
  }

function updateWearingList(equip,item,itemAttribute,WearingList){
    try{
        var wearingList = WearingList.get(itemAttribute)
        wearingList.name = item.name;
        wearingList.partner = item.partner;
        if(equip){
            WearingList.set(itemAttribute,wearingList)
        }else{
            WearingList.set(itemAttribute,{name:"",project:"",origin:wearingList.origin})
        }
    }catch{
        console.log("cannot find item Attribute")
    }
}

function isEmpty(str) {
    return (!str || str.length === 0 );
}

function isOrigin(wearingList,key){
    var attribute
    var partnerName
    if (isEmpty(wearingList.get(key).name)){
        if (isEmpty(wearingList.get(key).origin)){
            return null;
        }else
        attribute = wearingList.get(key).origin
    }else{
        attribute = wearingList.get(key).name
        partnerName = wearingList.get(key).partner+'/'
        attribute =partnerName.concat(attribute)
    }
    return attribute
}

function updateInventory(equip,item,itemAttribute,visualItemInventory){

    var testArray = new Array()
    var currentArray = visualItemInventory.get(itemAttribute)
    testArray.push(...currentArray)

    try{
        if(equip){
            testArray.push(item)
        }else{
            removeItemOnce(testArray,item)
        }    
    }catch{
        console.log("cannot find item to unequip " + item.name + "for " + itemAttribute)
    }
    visualItemInventory.set(itemAttribute,testArray)
}

function setAttachmentFull(player, playerFur, wearingList) {

    let furColor
    let fur
    let apparel
    let backWeapon
    let eyes
    let leftHand
    let rightHand
    let faceAccesory
    let hat
    let spirit

    for (let [key, value] of wearingList) {

        switch (key) {

            case "Fur":
                fur = isOrigin(wearingList,key)

                if (!isEmpty(fur)){
                    if (fur == "Orange Fur Black Ear" || fur == "Pink Fur Black Ear") {
                        furColor = "Fur/".concat(fur)
                        furColor += "s"
                        fur += "s"
                    } else {
                        furColor = "Fur/".concat(fur).slice(0, -4)
                    }     
                }
                break

            case "Apparel":

                apparel = isOrigin(wearingList,key)
                if (!isEmpty(apparel)){
                apparel = "Apparel/".concat(apparel)
                }
                break

            case "Back Weapon":
                backWeapon = isOrigin(wearingList,key)
                if (!isEmpty(backWeapon)){
                if(backWeapon.includes("Wings")){
                    backWeapon = backWeapon.concat("_Front_")
                }else{
                    backWeapon = backWeapon.concat("_Front_", key)
                }
                
                }
                break

            case "Eyes":

                eyes = isOrigin(wearingList,key)
                if(!isEmpty(eyes)){
                    eyes = eyes.concat("_Front_", key)
                }
                break

            case "Left Hand":

                leftHand = isOrigin(wearingList,key)
                if(!isEmpty(leftHand)){
                leftHand = leftHand.concat("_Front_", key)
                }
                break

            case "Right Hand":

                rightHand = isOrigin(wearingList,key)
                if(!isEmpty(rightHand)){
                rightHand = rightHand.concat("_Front_", key)
                }
                break

            case "Face Accessories":
                faceAccesory = isOrigin(wearingList,key)
                if(!isEmpty(faceAccesory)){
                faceAccesory = faceAccesory.concat("_Front_", "Face Accessories")
                }
                break
            
            case "Spirit":
                spirit = isOrigin(wearingList,key)
                if(!isEmpty(spirit)){
                spirit = spirit.concat("_Front_", "Spirit")
                }
                break

            case "Hat":

                hat = isOrigin(wearingList,key)
                if(!isEmpty(hat)){
                    hat = hat.replace("_", ":");
                    if(hat == "Epic Shroom w:Dahlys"){
                        hat = ""
                        break
                    }
                    hat = hat.concat("_Front_", "Hat")
                    var lastChar = hat.slice(hat.length - 1)
                    if(lastChar == 'i'){
                        hat = hat.slice(0, -1)
                    }
                }
                break
        }
    }

    switch (apparel) {

        case "Apparel/KungFu Master Robe":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat,spirit)
            break;

        case "Apparel/Rifleman Outfit":

            setSkin(playerFur, furColor)
            setSkin(player, apparel);
            setAttachmentSet(player, playerFur, null, eyes, leftHand, rightHand, faceAccesory, hat,spirit)
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            //SetAttachment(playerFur, "Front_Back Weapon", backWeapon)
            if(!isEmpty(backWeapon) ){
                if(backWeapon.includes("Wings")){
                    SetAttachment(playerFur, "Front_Right_Wing_1", backWeapon.concat("Right Wing"))
                    SetAttachment(playerFur, "Front_Left Wing", backWeapon.concat("Left Wing"))
                }else{
                    SetAttachment(playerFur, "Front_Back Weapon", backWeapon)
                }
            }
            SetAttachment(player, "Front_Right Palm", fur.concat("_Front_Right Palm"))
            SetAttachment(player, "Front_Right Arm", fur.concat("_Front_Right Arm"))
            break;

        case "Apparel/Knight Armor":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat,spirit)
            break;

        case "Apparel/Desert Fighter Outfit":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat,spirit)
            break;

        case "Apparel/Merchant Outfit":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat,spirit)
            break;

        case "Apparel/Artisan Outfit":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            SetAttachment(player, "Front_Body", fur.concat("_Front_Body"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat,spirit)
            break;

        case "Apparel/Travelling Poet Outfit":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat,spirit)
            break;

        case "Apparel/Shooter Outfit":

            setSkin(playerFur, furColor)
            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            setAttachmentSet(player, playerFur, null, eyes, leftHand, rightHand, faceAccesory, hat,spirit)
            if(!isEmpty(backWeapon) ){
                if(backWeapon.includes("Wings")){
                    SetAttachment(playerFur, "Front_Right_Wing_1", backWeapon.concat("Right Wing"))
                    SetAttachment(playerFur, "Front_Left Wing", backWeapon.concat("Left Wing"))
                }else{
                    SetAttachment(playerFur, "Front_Back Weapon", backWeapon)
                }
            }
            //SetAttachment(playerFur, "Front_Back Weapon", backWeapon)
            SetAttachment(player, "Front_Right Shoulder", fur.concat("_Front_Right Shoulder"))
            SetAttachment(player, "Front_Right Arm", fur.concat("_Front_Right Arm"))
            SetAttachment(player, "Front_Right Palm", fur.concat("_Front_Right Palm"))
            break;

        case "Apparel/Bandit Outfit":

            setSkin(playerFur, furColor)
            setSkin(player, apparel);
            setAttachmentSet(player, playerFur, null, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            if(!isEmpty(backWeapon)){
                if(backWeapon.includes("Wings")){
                    SetAttachment(playerFur, "Front_Right_Wing_1", backWeapon.concat("Right Wing"))
                    SetAttachment(playerFur, "Front_Left Wing", backWeapon.concat("Left Wing"))
                }else{
                    SetAttachment(playerFur, "Front_Back Weapon", backWeapon)
                }
            }
            //SetAttachment(playerFur, "Front_Back Weapon", backWeapon)
            SetAttachment(player, "Front_Body", furColor.concat("Front_Body"))
            break;

        case "Apparel/Samurai Armor":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            break;

        case "Apparel/Traveller Outfit":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            break;

        case "Apparel/Crusader Armor":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            break;

        case "Apparel/Sacred Warrior Armor":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            break;

        case "Apparel/Desert Traveller Outfit":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            SetAttachment(player, "Front_Right Arm", fur.concat("_Front_Right Arm"))
            SetAttachment(player, "Front_Right Leg", fur.concat("_Front_Right Leg"))
            SetAttachment(player, "Front_Left Leg", fur.concat("_Front_Left Leg"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            break;

        case "Apparel/Link Outfit":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            SetAttachment(player, "Front_Left Arm", fur.concat("_Front_Left Arm"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            break;

        case "Apparel/Ninja Outfit":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            SetAttachment(player, "Front_Left Arm", fur.concat("_Front_Left Arm"))
            SetAttachment(player, "Front_Left Shoulder", fur.concat("_Front_Left Shoulder"))
            SetAttachment(player, "Front_Right Shoulder", fur.concat("_Front_Right Shoulder"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            break;

        case "Apparel/Prince Costume":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            break;

        case "Apparel/Emperor Guardian Armor":

            setSkin(player, apparel);
            SetAttachment(player, "Front_Head", fur.concat("_Front_Head"))
            SetAttachment(player, "Front_Tail", fur.concat("_Front_Tail"))
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            break;

        default:

            var num = Math.floor(Math.random() * 1)

            setSkin(playerFur, furColor)

            switch (num) {
                case 0:
                    setSkin(player, "Apparel/BlackBlack Outfit");
                    break;
                case 1:
                    setSkin(player, "Apparel/BlackBlue Outfit");
                    break;
                case 2:
                    setSkin(player, "Apparel/BlackBrown Outfit");
                    break;
                case 3:
                    setSkin(player, "Apparel/WhiteBlack Outfit");
                    break;
                case 4:
                    setSkin(player, "Apparel/WhiteBlue Outfit");
                    break;
                case 5:
                    setSkin(player, "Apparel/WhiteBrown Outfit");
                    break;
            }

            SetAttachment(playerFur, "Front_Tail", fur.concat("_Front_Tail"))
            SetAttachment(player, "Front_Right Arm", fur.concat("_Front_Right Arm"))
            SetAttachment(player, "Front_Right Palm", fur.concat("_Front_Right Palm"))
            //setAttachment(player,)
            //player.setAttachment("Demon Skeleton Wing_Front_Right Wing","Guild Saga/Demon-Skeleton-Wing_Right_1")
            setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit)
            //SetAttachment(player, "mushroom hat", "mushroom hat/tile000")
            //setSkin(playerFur,"test")
            //SetAttachment(player,"Demon Skeleton_Front_Left Wing","Guild Saga/Demon-Skeleton-Wing_Left_1")
    }
}


function setAttachmentSet(player, playerFur, backWeapon, eyes, leftHand, rightHand, faceAccesory, hat, spirit) {
    debugger
    if(!isEmpty(backWeapon) ){
        if(backWeapon.includes("Wings")){
            SetAttachment(player, "Front_Right_Wing_1", backWeapon.concat("Right Wing"))
            SetAttachment(player, "Front_Left Wing", backWeapon.concat("Left Wing"))
        }else{
            SetAttachment(playerFur, "Front_Back Weapon", backWeapon)
        }
    }

    SetAttachment(player, "Front_Eyes", eyes)

    if(!isEmpty(leftHand) ){
    if (String(leftHand).includes("Shield")) {
        SetAttachment(player, "Front_Left_Shield", leftHand)
    } else {
        SetAttachment(playerFur, "Front_Left Hand", leftHand)
    }
    }


    SetAttachment(player, "Front_Right Hand", rightHand)

    SetAttachment(player, "Front_Face Accessories", faceAccesory)

    SetAttachment(player, "Front_Hat", hat)

    SetAttachment(playerFur,"Front_Spirit",spirit)


}

function getWearingList(attributeList,equipList){

}

let wearingList = new Map([["Fur",{name:"",partner:"",origin:""}],
                            ["Eyes",{name:"",partner:"",origin:""}],
                            ["Face Accessories",{name:"",partner:"",origin:""}],
                            ["Hat",{name:"",partner:"",origin:""}],
                            ["Apparel",{name:"",partner:"",origin:""}],
                            ["Left Hand",{name:"",partner:"",origin:""}],
                            ["Right Hand",{name:"",partner:"",origin:""}],
                            ["Spirit",{name:"",partner:"",origin:""}],
                            ["Back Weapon",{name:"",partner:"",origin:""}],
                            ])

let strWearingList 

let attributeList = []

export default class MainScene extends Phaser.Scene {

    constructor() {
        super({ key: 'MainScene' });
    }

    preload() {
    }
    init(data) {
        this.reactData = data;
    }
    create() {

        this.createRetroFonts();

        userName = this.reactData.userName;

        attributeList = this.reactData.nftMetaData.attributes;

 

        //partner
        visualItemList = this.reactData.ffItems;

        visualItemInventory = new Map([["Eyes",[]],
                                        ["Face Accessories",[]],
                                        ["Hat",[]],
                                        ["Apparel",[]],
                                        ["Left Hand",[]],
                                        ["Right Hand",[]],
                                        ["Spirit",[]],
                                        ["Back Weapon",[]]
                                        ])
        
        //updateInventory(true,{ name: "mushroom1", partner: "Guild Saga" },"Fur",visualItemInventory)
        if (visualItemList) {
            for (let i = 0; i < visualItemList.length; i++) {
                var visualItemName =  visualItemList[i].name;
                var lastIndex = visualItemName.lastIndexOf(" ");
                visualItemName = visualItemName.substring(0, lastIndex);
                visualItemName = visualItemName.replace("/", "_");
                var visualItemListSlot =  visualItemList[i].attributes[0].value;
                var visualItemListPartner =  visualItemList[i].attributes[2].value;
                if(visualItemInventory.has(visualItemListSlot)){
                    var visualItemInventoryArr = visualItemInventory.get(visualItemListSlot)
                    visualItemInventoryArr.push({name:visualItemName,partner:visualItemListPartner})
                }
                //attributeListConv[attributeList[i].trait_type] = attributeList[i].value
            }
        }
      
        
        for (let i = 0; i < attributeList.length; i++) {
            var wearingListKey =  attributeList[i].trait_type;
            if(wearingList.has(wearingListKey)){
                wearingList.set(wearingListKey,{name:"", partner:"",origin:attributeList[i].value})
            }
            //attributeListConv[attributeList[i].trait_type] = attributeList[i].value
        }

        //updateEquipList(true,{ name: "mushroom1", partner: "Guild Saga" },"Hat",wearingList)

        var tempArray = new Array()
        for (var visualItem in visualItemList){
            tempArray.push({name:visualItemList[visualItem].name,partner:visualItemList[visualItem].partner})
        }
        //visualItemInventory.set(visualItemList[visualItem].attribute,tempArray)
        let that = this;
        //  A simple background for our game
        let bg = this.add.image(12877 / 2, 10949 / 2, 'bg_complete').setScale(1);
        bg.depth = 0
        let island_shadow = this.add.image(12877 / 2, 10949 / 2, 'shadow1').setScale(1)
        island_shadow.depth = 0
        let island_shadow2 = this.add.image(12877 / 2, 10949 / 2, 'shadow2').setScale(1)
        island_shadow2.depth = 10

        ///buildings location 
        var building1_shapes = this.cache.json.get('building1_shapes');
        let building1 = this.matter.add.image(0, 0, 'building1', 'ground', { shape: building1_shapes.building_1 }).setScale(1);
        building1.setPosition(10189 + (building1.width * (building1.originX - 0.5)), 6890 + (building1.height * (building1.originY - 0.5)));
        building1.depth = building1.y
        building1.setCollisionCategory(category3);
        building1.setCollidesWith(category4);

        //    let shadow = this.add.image(10189+(building1.width*(building1.originX-0.5)), 6890+(building1.height*(building1.originY-0.5)), 'building1');
        //    shadow.setOrigin(0.6)
        //    shadow.tint = 0x000000;
        //    shadow.alpha = 0.3;

        var building2_shapes = this.cache.json.get('building2_shapes');
        let building2 = this.matter.add.image(0, 0, 'building2', 'ground', { shape: building2_shapes.building_2 }).setScale(1);
        building2.setPosition(10070 + (building2.width * (building2.originX - 0.5)), 4327 + (building2.height * (building2.originY - 0.5)));
        building2.depth = building2.y
        building2.setCollisionCategory(category3);
        building2.setCollidesWith(category4);

        var building3_shapes = this.cache.json.get('building3_shapes');
        let building3 = this.matter.add.image(0, 0, 'building3', 'ground', { shape: building3_shapes.building_3 }).setScale(1);
        building3.setPosition(4989 + (building3.width * (building3.originX - 0.5)), 4320 + (building3.height * (building3.originY - 0.5)));
        building3.depth = building3.y
        building3.setCollisionCategory(category3);
        building3.setCollidesWith(category4);

        var building4_shapes = this.cache.json.get('building4_shapes');
        let building4 = this.matter.add.image(3667, 6826, 'building4', 'ground', { shape: building4_shapes.building_4 }).setScale(1);
        building4.setPosition(3667 + (building4.width * (building4.originX - 0.5)), 6826 + (building4.height * (building4.originY - 0.5)));
        building4.depth = building4.y
        building4.setCollisionCategory(category3);
        building4.setCollidesWith(category4);

        var building5_shapes = this.cache.json.get('building5_shapes');
        let building5 = this.matter.add.sprite(0, 0, 'building5', 'ground', { shape: building5_shapes.building_5 }).setScale(1);
        building5.setPosition(5652 + (building5.width * (building5.originX - 0.5)), 3192 + (building5.height * (building5.originY - 0.5)));
        building5.depth = building5.y
        building5.setCollisionCategory(category3);
        building5.setCollidesWith(category4);

        var building6_shapes = this.cache.json.get('building6_shapes');
        let building6 = this.matter.add.image(8234, 4699, 'building6', 'ground', { shape: building5_shapes.building_6 }).setScale(1);
        building6.setPosition(8234 + (building6.width * (building6.originX - 0.5)), 4699 + (building6.height * (building6.originY - 0.5)));
        building6.depth = building6.y
        building6.setCollisionCategory(category3);
        building6.setCollidesWith(category4);

        var building7_shapes = this.cache.json.get('building7_shapes');
        let building7 = this.matter.add.image(6034, 6307, 'building7', 'ground', { shape: building7_shapes.building_7 }).setScale(1);
        building7.setPosition(6034 + (building7.width * (building7.originX - 0.5)), 6307 + (building7.height * (building7.originY - 0.5)));
        building7.depth = building7.y
        building7.setCollisionCategory(category3);
        building7.setCollidesWith(category4);

        //    let shadow_building7 = this.add.image(6034+(building7.width*(building7.originX-0.5)), 6307+(building7.height*(building7.originY-0.5)), 'building7');
        //    shadow_building7.setOrigin(0.6)
        //    shadow_building7.tint = 0x000000;
        //    shadow_building7.alpha = 0.4;

        var building8_shapes = this.cache.json.get('building8_shapes');
        let building8 = this.matter.add.image(7165, 3563, 'building8', 'ground', { shape: building8_shapes.building_8 }).setScale(1);
        building8.setPosition(7165 + (building8.width * (building8.originX - 0.5)), 3563 + (building8.height * (building8.originY - 0.5)));
        building8.depth = building8.y + 100
        building8.setCollisionCategory(category3);
        building8.setCollidesWith(category4);

        var island_shapes = this.cache.json.get('island_shapes');
        let island = this.matter.add.image(7040, 7275, 'empty_image', 'ground', { shape: island_shapes.island }).setScale(4);
        let island2 = this.matter.add.image(9799, 4632, 'empty_image', 'ground', { shape: island_shapes.island2 }).setScale(1);
        let island3 = this.matter.add.image(7900, 6690, 'empty_image', 'ground', { shape: island_shapes.island3 }).setScale(1);
        let island4 = this.matter.add.image(4020, 5750, 'empty_image', 'ground', { shape: island_shapes.island4 }).setScale(1);
        let island5 = this.matter.add.image(6920, 2702, 'island5', 'ground', { shape: island_shapes.island5 }).setScale(1);
        let island6 = this.matter.add.image(8754, 3912, 'island6', 'ground', { shape: island_shapes.island6 }).setScale(1);


        island.setCollisionCategory(category3);
        island.setCollidesWith(category4);
        island2.setCollisionCategory(category3);
        island2.setCollidesWith(category4);
        island3.setCollisionCategory(category3);
        island3.setCollidesWith(category4);
        island4.setCollisionCategory(category3);
        island4.setCollidesWith(category4);
        island5.setCollisionCategory(category3);
        island5.setCollidesWith(category4);
        island6.setCollisionCategory(category3);
        island6.setCollidesWith(category4);


        //props
        var props1_shapes = this.cache.json.get('props1_shapes');
        let bush2_coordinates = [[7363, 1966], [7540, 2077], [5557, 9438], [5981, 9232], [6266, 8506], [4545, 8176], [3134, 5208], [2388, 4817], [10552, 6902], [10792, 4957]
            , [8781, 4578], [8599, 4458], [7823, 6586], [7367, 6385], [7227, 6277], [6761, 5858]]


        for (var i = 0; i < bush2_coordinates.length; i++) {
            var bush2 = this.add.image(0, 0, 'bush2').setScale(1)
            bush2.setPosition(bush2_coordinates[i][0] + (bush2.width * (bush2.originX - 0.5)), bush2_coordinates[i][1] + (bush2.height * (bush2.originY - 0.5)));
            bush2.depth = bush2.y + 90
        }

        let bush1_coordinates = [[10707, 7033], [6330, 8295], [5920, 8444], [5482, 9252], [3116, 8485], [2614, 7635], [2885, 7173], [2701, 6020], [3007, 5356], [2832, 5030]
        ]

        for (var i = 0; i < bush1_coordinates.length; i++) {
            //var bush1_shapes = this.cache.json.get('bush1_shapes');
            //var bush2 = this.matter.add.image(0, 0, 'bush2', 'ground', {shape: bush2_shapes._0000_bush_2}).setScale(1);
            var bush1 = this.add.image(0, 0, 'bush1').setScale(1)
            bush1.setPosition(bush1_coordinates[i][0] + (bush1.width * (bush1.originX - 0.5)), bush1_coordinates[i][1] + (bush1.height * (bush1.originY - 0.5)));
            bush1.depth = bush1.y + 90

        }

        let leaf1_coordinates = [[5291, 2633]]

        for (var i = 0; i < leaf1_coordinates.length; i++) {
            var leaf1 = this.add.sprite(0, 0, 'leaf1').setScale(1)
            this.anims.create({
                key: "leaf1_animate",
                frames: this.anims.generateFrameNumbers("leaf1"),
                frameRate: 20,
                repeat: -1
            })
            leaf1.setPosition(leaf1_coordinates[i][0] + (leaf1.width * (leaf1.originX - 0.5)), leaf1_coordinates[i][1] + (leaf1.height * (leaf1.originY - 0.5)));
            leaf1.depth = leaf1.y + 90
            leaf1.play('leaf1_animate')
        }

        let tree1_coordinates = [[2395, 1713], [7825, 1755], [5220, 1942], [4446, 2475], [2541, 4268], [3334, 6278], [4653, 6015], [5982, 8060], [10944, 4521], [8947, 4081], [8440, 2853], [3932, 2843]]

        for (var i = 0; i < tree1_coordinates.length; i++) {
            var tree1 = this.matter.add.image(0, 0, 'tree1', 'ground', { shape: props1_shapes._0003_tree_1 }).setScale(1);
            tree1.setPosition(tree1_coordinates[i][0] + (tree1.width * (tree1.originX - 0.5)), tree1_coordinates[i][1] + (tree1.height * (tree1.originY - 0.5)));
            if (i % 2 == 0) {
                tree1.flipX = true
            }
            tree1.depth = tree1.y
            tree1.setCollisionCategory(category3);
            tree1.setCollidesWith(category4);
        }

        let tree2_coordinates = [[7933, 724], [8321, 456], [8996, 684], [9224, 1069], [9806, 1182], [7408, 1526], [6175, 1869], [5583, 2164], [3477, 2658], [2795, 1472], [3468, 3650],
        [2897, 4611], [4986, 5670], [2791, 6742], [3998, 8108], [5677, 9023], [10685, 6539], [11406, 5405], [11193, 4005], [10854, 3703], [8804, 2589], [10367, 2443]]

        for (var i = 0; i < tree2_coordinates.length; i++) {
            var tree2 = this.matter.add.image(0, 0, 'tree2', 'ground', { shape: props1_shapes._0004_tree_2 }).setScale(1);
            tree2.setPosition(tree2_coordinates[i][0] + (tree2.width * (tree2.originX - 0.5)), tree2_coordinates[i][1] + (tree2.height * (tree2.originY - 0.5)));
            if (i % 2 == 0) {
                tree2.flipX = true
            }
            tree2.depth = tree2.y
            tree2.setCollisionCategory(category3);
            tree2.setCollidesWith(category4);
        }


        let carrot1_coordinates = [[4494, 8604]]

        for (var i = 0; i < carrot1_coordinates.length; i++) {
            var carrot1 = this.matter.add.sprite(0, 0, 'carrot1', '0005_Carrot_1_639_X_723-min1', { shape: props1_shapes._0005_carrot_1 }).setScale(1)
            this.anims.create({
                key: "carrot1_animate",
                frames: this.anims.generateFrameNumbers("carrot1"),
                frameRate: 20,
                repeat: -1
            })
            carrot1.setPosition(carrot1_coordinates[i][0] + (carrot1.width * (carrot1.originX - 0.5)), carrot1_coordinates[i][1] + (carrot1.height * (carrot1.originY - 0.5)));
            carrot1.depth = carrot1.y + 90
            carrot1.play('carrot1_animate')
            carrot1.setCollisionCategory(category3);
            carrot1.setCollidesWith(category4);
        }

        let carrot2_coordinates = [[5034, 8495]]

        for (var i = 0; i < carrot2_coordinates.length; i++) {
            var carrot2 = this.matter.add.sprite(0, 0, 'carrot2', '0006_Carrot_2_413_X_468-min1', { shape: props1_shapes._0006_carrot_2 }).setScale(1)
            this.anims.create({
                key: "carrot2_animate",
                frames: this.anims.generateFrameNumbers("carrot2"),
                frameRate: 20,
                repeat: -1
            })
            carrot2.setPosition(carrot2_coordinates[i][0] + (carrot2.width * (carrot2.originX - 0.5)), carrot2_coordinates[i][1] + (carrot2.height * (carrot2.originY - 0.5)));
            carrot2.depth = carrot2.y + 90
            carrot2.play('carrot2_animate')
            carrot2.setCollisionCategory(category3);
            carrot2.setCollidesWith(category4);
        }

        let leaf2_coordinates = [[11572, 5717], [2610, 3270]]

        for (var i = 0; i < leaf2_coordinates.length; i++) {
            var leaf2 = this.add.sprite(0, 0, 'leaf2').setScale(1)
            if (i == 0) {
                leaf2.flipX = true
            }
            this.anims.create({
                key: "leaf2_animate",
                frames: this.anims.generateFrameNumbers("leaf2"),
                frameRate: 20,
                repeat: -1
            })
            leaf2.setPosition(leaf2_coordinates[i][0] + (leaf2.width * (leaf2.originX - 0.5)), leaf2_coordinates[i][1] + (leaf2.height * (leaf2.originY - 0.5)));
            leaf2.depth = leaf2.y + 90
            leaf2.play('leaf2_animate')
        }

        let leaf4_coordinates = [[2981, 7920], [9884, 3577], [10116, 2103], [7384, 3177]]

        for (var i = 0; i < leaf4_coordinates.length; i++) {
            var leaf4 = this.add.sprite(0, 0, 'leaf4').setScale(1)
            if (i == 0) {
                leaf4.flipX = true
            }
            this.anims.create({
                key: "leaf4_animate",
                frames: this.anims.generateFrameNumbers("leaf4"),
                frameRate: 20,
                repeat: -1
            })
            leaf4.setPosition(leaf4_coordinates[i][0] + (leaf4.width * (leaf4.originX - 0.5)), leaf4_coordinates[i][1] + (leaf4.height * (leaf4.originY - 0.5)));
            leaf4.depth = leaf4.y + 200
            leaf4.play('leaf4_animate')
        }


        let leaf3_coordinates = [[11970, 2693]]

        for (var i = 0; i < leaf3_coordinates.length; i++) {
            var leaf3 = this.add.sprite(0, 0, 'leaf3').setScale(1)
            this.anims.create({
                key: "leaf3_animate",
                frames: this.anims.generateFrameNumbers("leaf3"),
                frameRate: 20,
                repeat: -1
            })
            leaf3.setPosition(leaf3_coordinates[i][0] + (leaf3.width * (leaf3.originX - 0.5)), leaf3_coordinates[i][1] + (leaf3.height * (leaf3.originY - 0.5)));
            leaf3.depth = leaf3.y
            leaf3.play('leaf3_animate')
        }

        let leaf7_coordinates = [[11220, 7092]]

        for (var i = 0; i < leaf7_coordinates.length; i++) {
            var leaf7 = this.add.sprite(0, 0, 'leaf7').setScale(1)
            this.anims.create({
                key: "leaf7_animate",
                frames: this.anims.generateFrameNumbers("leaf7"),
                frameRate: 20,
                repeat: -1
            })
            leaf7.setPosition(leaf7_coordinates[i][0] + (leaf7.width * (leaf7.originX - 0.5)), leaf7_coordinates[i][1] + (leaf7.height * (leaf7.originY - 0.5)));
            leaf7.depth = leaf7.y
            leaf7.play('leaf7_animate')
            leaf7.flipX = true
        }

        //    let leaf6_coordinates = [[4492,3913]]

        //    for (var i = 0; i < leaf6_coordinates.length; i++)
        //    {
        //        var leaf6 = this.add.sprite(0,0,'leaf6').setScale(1)
        //        this.anims.create({
        //         key: "leaf6_animate",
        //         frames: this.anims.generateFrameNumbers("leaf6"),
        //         frameRate: 20,
        //         repeat: -1
        //     })  
        //         leaf6.setPosition(leaf6_coordinates[i][0]+(leaf6.width*(leaf6.originX-0.5)), leaf6_coordinates[i][1]+(leaf6.height*(leaf6.originY-0.5)));
        //         leaf6.depth = leaf6.y
        //         leaf6.play('leaf6_animate')
        //         leaf6.flipX = true
        //    }

        let leaf9_coordinates = [[1912, 4894]]

        for (var i = 0; i < leaf9_coordinates.length; i++) {
            var leaf9 = this.add.sprite(0, 0, 'leaf9').setScale(1)
            this.anims.create({
                key: "leaf9_animate",
                frames: this.anims.generateFrameNumbers("leaf9"),
                frameRate: 20,
                repeat: -1
            })
            leaf9.setPosition(leaf9_coordinates[i][0] + (leaf9.width * (leaf9.originX - 0.5)), leaf9_coordinates[i][1] + (leaf9.height * (leaf9.originY - 0.5)));
            leaf9.depth = leaf9.y
            leaf9.play('leaf9_animate')
        }

        let leaf10_coordinates = [[4593, 3892]]

        for (var i = 0; i < leaf10_coordinates.length; i++) {
            var leaf10 = this.add.sprite(0, 0, 'leaf10').setScale(1)
            this.anims.create({
                key: "leaf10_animate",
                frames: this.anims.generateFrameNumbers("leaf10"),
                frameRate: 20,
                repeat: -1
            })
            leaf10.setPosition(leaf10_coordinates[i][0] + (leaf10.width * (leaf10.originX - 0.5)), leaf10_coordinates[i][1] + (leaf10.height * (leaf10.originY - 0.5)));
            leaf10.depth = leaf10.y
            leaf10.play('leaf10_animate')
        }

        let leaf13_coordinates = [[2300, 4810]]

        for (var i = 0; i < leaf13_coordinates.length; i++) {
            var leaf13 = this.add.sprite(0, 0, 'leaf13').setScale(1)
            this.anims.create({
                key: "leaf13_animate",
                frames: this.anims.generateFrameNumbers("leaf13"),
                frameRate: 20,
                repeat: -1
            })
            leaf13.setPosition(leaf13_coordinates[i][0] + (leaf13.width * (leaf13.originX - 0.5)), leaf13_coordinates[i][1] + (leaf13.height * (leaf13.originY - 0.5)));
            leaf13.depth = leaf13.y
            leaf13.play('leaf13_animate')
        }

        //    var leaf13 = this.add.image(0, 0, 'leaf13').setScale(1);
        //    leaf13.setPosition(1700+(leaf13.width-leaf13.displayOriginX), 4810+(leaf13.height-leaf13.displayOriginY/2));    
        //    leaf13.depth = leaf13.y+200

        //    var leaf9 = this.add.image(0, 0, 'leaf9').setScale(1);
        //    leaf9.setPosition(2132+(leaf9.width-leaf9.displayOriginX), 4894+(leaf9.height-leaf9.displayOriginY/2));    
        //    leaf9.depth = leaf9.y+200

        //    var leaf10 = this.add.image(0, 0, 'leaf10').setScale(1);
        //    leaf10.setPosition(4093+(leaf10.width-leaf10.displayOriginX), 3892+(leaf10.height-leaf10.displayOriginY/2));    
        //    leaf10.depth = leaf10.y+200

        // //    var leaf6 = this.add.image(0, 0, 'leaf6').setScale(1);
        // //    leaf6.setPosition(4492+(leaf6.width-leaf6.displayOriginX), 4013+(leaf6.height-leaf6.displayOriginY/2));    
        // //    leaf6.depth = leaf6.y+200

        //    var leaf5 = this.add.image(0, 0, 'leaf5').setScale(1);
        //    leaf5.setPosition(3096+(leaf5.width*(leaf5.originX-0.5)), 1669+(leaf5.height*(leaf5.originY-0.5)));    
        //    leaf5.depth = leaf5.y

        //    var leaf6 = this.add.image(0, 0, 'leaf6').setScale(1);
        //    leaf6.setPosition(4492+(leaf6.width-leaf6.displayOriginX), 4013+(leaf6.height-leaf6.displayOriginY/2));    
        //    leaf6.depth = leaf6.y+200

        //    var leaf4 = this.add.image(0, 0, 'leaf4').setScale(-1,1);
        //    leaf4.setPosition(2681+(leaf4.width-leaf4.displayOriginX), 7920+(leaf4.height-leaf4.displayOriginY/2));    
        //    leaf4.depth = leaf4.y+300
        //    leaf4.flipX = true

        //    var leaf7 = this.add.image(0, 0, 'leaf7').setScale(-1,1);
        //    leaf7.setPosition(10990+(leaf7.width-leaf7.displayOriginX), 7092+(leaf7.height-leaf7.displayOriginY/2));    
        //    leaf7.depth = leaf7.y
        //    leaf7.flipX = true



        //    var leaf2 = this.add.image(0, 0, 'leaf2').setScale(-1,1);
        //    leaf2.setPosition(11272+(leaf2.width-leaf2.displayOriginX), 5717+(leaf2.height-leaf2.displayOriginY/2));    
        //    leaf2.depth = leaf2.y

        //    var leaf4_2 = this.add.image(0, 0, 'leaf4').setScale(1);
        //    leaf4_2.setPosition(9384+(leaf4_2.width-leaf4_2.displayOriginX), 3577+(leaf4_2.height-leaf4_2.displayOriginY/2));    
        //    leaf4_2.depth = leaf4_2.y

        //    var leaf3 = this.add.image(0, 0, 'leaf3').setScale(1);
        //    leaf3.setPosition(11570+(leaf3.width-leaf3.displayOriginX), 2693+(leaf3.height-leaf3.displayOriginY/2));    
        //    leaf3.depth = leaf3.y

        //    var leaf4_3 = this.add.image(0, 0, 'leaf4').setScale(1);
        //    leaf4_3.setPosition(9616+(leaf4_3.width-leaf4_3.displayOriginX), 2103+(leaf4_3.height-leaf4_3.displayOriginY/2));    
        //    leaf4_3.depth = leaf4_3.y



        //    var leaf2_2 = this.add.image(0, 0, 'leaf2').setScale(1);
        //    leaf2_2.setPosition(2610+(leaf2_2.width-leaf2_2.displayOriginX), 3270+(leaf2_2.height-leaf2_2.displayOriginY/2));    
        //    leaf2_2.depth = leaf2_2.y+200

        //    var leaf13 = this.add.image(0, 0, 'leaf13').setScale(1);
        //    leaf13.setPosition(1700+(leaf13.width-leaf13.displayOriginX), 4810+(leaf13.height-leaf13.displayOriginY/2));    
        //    leaf13.depth = leaf13.y+200

        //    var leaf9 = this.add.image(0, 0, 'leaf9').setScale(1);
        //    leaf9.setPosition(2132+(leaf9.width-leaf9.displayOriginX), 4894+(leaf9.height-leaf9.displayOriginY/2));    
        //    leaf9.depth = leaf9.y+200

        //    var leaf10 = this.add.image(0, 0, 'leaf10').setScale(1);
        //    leaf10.setPosition(4093+(leaf10.width-leaf10.displayOriginX), 3892+(leaf10.height-leaf10.displayOriginY/2));    
        //    leaf10.depth = leaf10.y+200

        //    var leaf6 = this.add.image(0, 0, 'leaf6').setScale(1);
        //    leaf6.setPosition(4492+(leaf6.width-leaf6.displayOriginX), 4013+(leaf6.height-leaf6.displayOriginY/2));    
        //    leaf6.depth = leaf6.y+200

        var rockwall_1 = this.matter.add.image(0, 0, 'rockwall1', 'ground', { shape: props1_shapes._0019_rockwall_1 }).setScale(1);
        rockwall_1.setPosition(8622 + (rockwall_1.width * (rockwall_1.originX - 0.5)), 5399 + (rockwall_1.height * (rockwall_1.originY - 0.5)));
        rockwall_1.depth = rockwall_1.y + 15
        rockwall_1.setCollisionCategory(category3);
        rockwall_1.setCollidesWith(category4);

        var rockwall_2 = this.matter.add.image(0, 0, 'rockwall2', 'ground', { shape: props1_shapes._0020_rockwall_2 }).setScale(1);
        rockwall_2.setPosition(9712 + (rockwall_2.width * (rockwall_2.originX - 0.5)), 5940 + (rockwall_2.height * (rockwall_2.originY - 0.5)));
        rockwall_2.depth = rockwall_2.y + 15
        rockwall_2.setCollisionCategory(category3);
        rockwall_2.setCollidesWith(category4);

        var postbox = this.matter.add.image(0, 0, 'postbox', 'ground', { shape: props1_shapes._0021_postbox }).setScale(1);
        postbox.setPosition(10648 + (postbox.width * (postbox.originX - 0.5)), 7432 + (postbox.height * (postbox.originY - 0.5)));
        postbox.depth = postbox.y
        postbox.setCollisionCategory(category3);
        postbox.setCollidesWith(category4);


        var lamppost = this.matter.add.image(0, 0, 'lamppost', 'ground', { shape: props1_shapes._0022_lamppost }).setScale(1);
        lamppost.setPosition(10240 + (lamppost.width * (lamppost.originX - 0.5)), 5036 + (lamppost.height * (lamppost.originY - 0.5)));
        lamppost.depth = lamppost.y
        lamppost.setCollisionCategory(category3);
        lamppost.setCollidesWith(category4);

        var fence_1 = this.matter.add.image(0, 0, 'fence1', 'ground', { shape: props1_shapes._0023_fence_1 }).setScale(1);
        fence_1.setPosition(7025 + (fence_1.width * (fence_1.originX - 0.5)), 4561 + (fence_1.height * (fence_1.originY - 0.5)));
        fence_1.depth = fence_1.y
        fence_1.setCollisionCategory(category3);
        fence_1.setCollidesWith(category4);

        var fence_2 = this.matter.add.image(0, 0, 'fence2', 'ground', { shape: props1_shapes._0024_fence_2 }).setScale(1);
        fence_2.setPosition(7305 + (fence_2.width * (fence_2.originX - 0.5)), 4723 + (fence_2.height * (fence_2.originY - 0.5)));
        fence_2.depth = fence_2.y
        fence_2.setCollisionCategory(category3);
        fence_2.setCollidesWith(category4);

        var fence_1_2 = this.matter.add.image(0, 0, 'fence1', 'ground', { shape: props1_shapes._0023_fence_1 }).setScale(-1, 1);
        fence_1_2.setPosition(3228 + (fence_1_2.width * (fence_1_2.originX - 0.5)), 7470 + (fence_1_2.height * (fence_1_2.originY - 0.5)));
        fence_1_2.depth = fence_1_2.y
        fence_1_2.setCollisionCategory(category3);
        fence_1_2.setCollidesWith(category4);

        var fence_2_2 = this.matter.add.image(0, 0, 'fence2', 'ground', { shape: props1_shapes._0024_fence_2 }).setScale(-1, 1);
        fence_2_2.setPosition(4218 + (fence_2_2.width * (fence_2_2.originX - 0.5)), 7000 + (fence_2_2.height * (fence_2_2.originY - 0.5)));
        fence_2_2.depth = fence_2_2.y - 50
        fence_2_2.setCollisionCategory(category3);
        fence_2_2.setCollidesWith(category4);

        var fence_1_3 = this.matter.add.image(0, 0, 'fence1', 'ground', { shape: props1_shapes._0023_fence_1 }).setScale(1);
        fence_1_3.setPosition(5837 + (fence_1_3.width * (fence_1_3.originX - 0.5)), 3149 + (fence_1_3.height * (fence_1_3.originY - 0.5)));
        fence_1_3.depth = fence_1_3.y
        fence_1_3.setCollisionCategory(category3);
        fence_1_3.setCollidesWith(category4);

        var fence_3_3 = this.matter.add.image(0, 0, 'fence2', 'ground', { shape: props1_shapes._0024_fence_2 }).setScale(1);
        fence_3_3.setPosition(6124 + (fence_3_3.width * (fence_3_3.originX - 0.5)), 3289 + (fence_3_3.height * (fence_3_3.originY - 0.5)));
        fence_3_3.depth = fence_3_3.y - 50
        fence_3_3.setCollisionCategory(category3);
        fence_3_3.setCollidesWith(category4);

        var fence_1_4 = this.matter.add.image(0, 0, 'fence1', 'ground', { shape: props1_shapes._0023_fence_1 }).setScale(-1, 1);

        fence_1_4.setPosition(4507 + (fence_1_4.width * (fence_1_4.originX - 0.5)), 5077 + (fence_1_4.height * (fence_1_4.originY - 0.5)));

        fence_1_4.depth = fence_1_4.y

        fence_1_4.setCollisionCategory(category3);

        fence_1_4.setCollidesWith(category4);



        var fence_2_4 = this.matter.add.image(0, 0, 'fence2', 'ground', { shape: props1_shapes._0024_fence_2 }).setScale(-1, 1);

        fence_2_4.setPosition(4264 + (fence_2_4.width * (fence_2_4.originX - 0.5)), 5241 + (fence_2_4.height * (fence_2_4.originY - 0.5)));

        fence_2_4.depth = fence_2_4.y - 50

        fence_2_4.setCollisionCategory(category3);

        fence_2_4.setCollidesWith(category4)


        var box_1 = this.matter.add.image(0, 0, 'box1', 'ground', { shape: props1_shapes._0025_box_1 }).setScale(1);
        box_1.setPosition(4345 + (box_1.width * (box_1.originX - 0.5)), 4788 + (box_1.height * (box_1.originY - 0.5)));
        box_1.depth = box_1.y
        box_1.setCollisionCategory(category3);
        box_1.setCollidesWith(category4);


        var box_2 = this.matter.add.image(0, 0, 'box2', 'ground', { shape: props1_shapes._0026_box_2 }).setScale(1);
        box_2.setPosition(4367 + (box_2.width * (box_2.originX - 0.5)), 4921 + (box_2.height * (box_2.originY - 0.5)));
        box_2.depth = box_2.y
        box_2.setCollisionCategory(category3);
        box_2.setCollidesWith(category4);

        var box_3 = this.matter.add.image(0, 0, 'box3', 'ground', { shape: props1_shapes._0027_box_3 }).setScale(1);
        box_3.setPosition(4366 + (box_3.width * (box_3.originX - 0.5)), 4674 + (box_3.height * (box_3.originY - 0.5)));
        box_3.depth = box_3.y + 100
        box_3.setCollisionCategory(category3);
        box_3.setCollidesWith(category4);


        var box_4 = this.matter.add.image(0, 0, 'box4', 'ground', { shape: props1_shapes._0028_box_4 }).setScale(1);
        box_4.setPosition(4541 + (box_4.width * (box_4.originX - 0.5)), 4818 + (box_4.height * (box_4.originY - 0.5)));
        box_4.depth = box_4.y
        box_4.setCollisionCategory(category3);
        box_4.setCollidesWith(category4);


        let whitecarrot_coordinates = [[3552, 4191], [9498, 3223], [8523, 877], [6680, 1565]]

        for (var i = 0; i < whitecarrot_coordinates.length; i++)
        //    {
        //        var whitecarrot = this.add.image(0,0,'whitecarrot')
        //        var whitecarrot_collision = this.matter.add.image(0, 0,'empty_image','ground', {shape: props1_shapes._0029_whitecarrot}).setScale(1);
        //        whitecarrot.setPosition(whitecarrot_coordinates[i][0]-320+(whitecarrot.width-whitecarrot.displayOriginX), whitecarrot_coordinates[i][1]+(whitecarrot.height-whitecarrot.displayOriginY/2));
        //        whitecarrot_collision.setPosition(whitecarrot_coordinates[i][0]-320+(whitecarrot.width-whitecarrot.displayOriginX), whitecarrot_coordinates[i][1]-60+(whitecarrot.height-whitecarrot.displayOriginY/2));
        //        whitecarrot.depth = whitecarrot.y-100
        //        whitecarrot_collision.setCollisionCategory(category3);
        //        whitecarrot_collision.setCollidesWith(category4);

        //    }   
        {
            var whitecarrot = this.matter.add.sprite(0, 0, 'whitecarrot', 'ground', { shape: props1_shapes._0029_whitecarrot }).setScale(1)
            this.anims.create({
                key: "whitecarrot_animate",
                frames: this.anims.generateFrameNumbers("whitecarrot"),
                frameRate: 20,
                repeat: -1
            })
            whitecarrot.setPosition(whitecarrot_coordinates[i][0] + (whitecarrot.width * (whitecarrot.originX - 0.5)), whitecarrot_coordinates[i][1] + (whitecarrot.height * (whitecarrot.originY - 0.5)));
            whitecarrot.depth = whitecarrot.y
            whitecarrot.play('whitecarrot_animate')
        }


        let pinkcarrot_coordinates = [[7031, 1777], [4208, 3138]]

        for (var i = 0; i < pinkcarrot_coordinates.length; i++)
        //    {
        //        var pinkcarrot = this.add.image(0,0,'pinkcarrot')
        //        var pinkcarrot_collision = this.matter.add.image(0, 0, 'empty_image','ground', {shape: props1_shapes._0030_pinkcarrot}).setScale(1);
        //        pinkcarrot.setPosition(pinkcarrot_coordinates[i][0]-370+(pinkcarrot.width-pinkcarrot.displayOriginX), pinkcarrot_coordinates[i][1]+620+(pinkcarrot.width-pinkcarrot.displayOriginY));
        //        pinkcarrot_collision.setPosition(pinkcarrot_coordinates[i][0]-370+(pinkcarrot.width-pinkcarrot.displayOriginX), pinkcarrot_coordinates[i][1]+570+(pinkcarrot.width-pinkcarrot.displayOriginY));
        //        pinkcarrot.depth = pinkcarrot.y
        //        pinkcarrot_collision.setCollisionCategory(category3);
        //        pinkcarrot_collision.setCollidesWith(category4);
        //    }    
        {
            var pinkcarrot = this.matter.add.sprite(0, 0, 'pinkcarrot', 'ground', { shape: props1_shapes._0030_pinkcarrot }).setScale(1)
            this.anims.create({
                key: "pinkcarrot_animate",
                frames: this.anims.generateFrameNumbers("pinkcarrot"),
                frameRate: 20,
                repeat: -1
            })
            pinkcarrot.setPosition(pinkcarrot_coordinates[i][0] + (pinkcarrot.width * (pinkcarrot.originX - 0.5)), pinkcarrot_coordinates[i][1] + (pinkcarrot.height * (pinkcarrot.originY - 0.5)));
            pinkcarrot.depth = pinkcarrot.y
            pinkcarrot.play('pinkcarrot_animate')
        }

        let mushroom1_coordinates = [[3999, 4000], [6513, 2206]]

        for (var i = 0; i < mushroom1_coordinates.length; i++) {
            var mushroom_1 = this.matter.add.image(0, 0, 'mushroom1', 'ground', { shape: props1_shapes._0031_mushroom_1 }).setScale(1);
            mushroom_1.setPosition(mushroom1_coordinates[i][0] + (mushroom_1.width * (mushroom_1.originX - 0.5)), mushroom1_coordinates[i][1] + (mushroom_1.height * (mushroom_1.originY - 0.5)));
            mushroom_1.depth = mushroom_1.y
            mushroom_1.setCollisionCategory(category3);
            mushroom_1.setCollidesWith(category4);
            if (i == 1) {
                mushroom_1.setScale(-1, 1)
            }
        }

        let mushroom2_coordinates = [[4418, 3617], [11591, 4629], [7972, 2217]]

        for (var i = 0; i < mushroom2_coordinates.length; i++) {
            var mushroom_2 = this.matter.add.image(0, 0, 'mushroom2', 'ground', { shape: props1_shapes._0032_mushroom_2 }).setScale(1);
            mushroom_2.setPosition(mushroom2_coordinates[i][0] + (mushroom_2.width * (mushroom_2.originX - 0.5)), mushroom2_coordinates[i][1] + (mushroom_2.height * (mushroom_2.originY - 0.5)));
            mushroom_2.depth = mushroom_2.y
            mushroom_2.setCollisionCategory(category3);
            mushroom_2.setCollidesWith(category4);
        }

        let grass1_coordinates = [[3933, 4890], [6187, 2536], [9622, 2663], [10686, 5147], [7428, 9171]]

        for (var i = 0; i < grass1_coordinates.length; i++)
        //    {
        //        var grass_1 = this.add.image(0, 0, 'grass1').setScale(1);
        //        grass_1.setPosition(grass1_coordinates[i][0]+(grass_1.width-grass_1.displayOriginX), grass1_coordinates[i][1]+(grass_1.width-grass_1.displayOriginY));
        //        grass_1.depth = grass_1.y
        //    } 
        {
            var grass1 = this.add.sprite(0, 0, 'grass1', 'ground').setScale(1)
            this.anims.create({
                key: "grass1_animate",
                frames: this.anims.generateFrameNumbers("grass1"),
                frameRate: 20,
                repeat: -1
            })
            grass1.setPosition(grass1_coordinates[i][0] + (grass1.width * (grass1.originX - 0.5)), grass1_coordinates[i][1] + (grass1.height * (grass1.originY - 0.5)));
            grass1.depth = grass1.y
            grass1.play('grass1_animate')
        }

        let grass2_coordinates = [[6274, 2667], [7319, 2820], [10333, 6057], [9262, 8623], [6684, 9546]]

        for (var i = 0; i < grass2_coordinates.length; i++)
        //    {
        //        var grass_2 = this.add.image(0, 0, 'grass2').setScale(1);
        //        grass_2.setPosition(grass2_coordinates[i][0]+(grass_2.width-grass_2.displayOriginX), grass2_coordinates[i][1]+(grass_2.width-grass_2.displayOriginY));
        //        grass_2.depth = grass_2.y
        //    }
        {
            var grass2 = this.add.sprite(0, 0, 'grass2', 'ground').setScale(1)
            this.anims.create({
                key: "grass2_animate",
                frames: this.anims.generateFrameNumbers("grass2"),
                frameRate: 20,
                repeat: -1
            })
            grass2.setPosition(grass2_coordinates[i][0] + (grass2.width * (grass2.originX - 0.5)), grass2_coordinates[i][1] + (grass2.height * (grass2.originY - 0.5)));
            grass2.depth = grass2.y
            grass2.play('grass2_animate')
        }

        let grass3_coordinates = [[8383, 9154]]

        for (var i = 0; i < grass3_coordinates.length; i++) {
            var grass3 = this.add.sprite(0, 0, 'grass3', 'ground').setScale(1)
            this.anims.create({
                key: "grass3_animate",
                frames: this.anims.generateFrameNumbers("grass3"),
                frameRate: 20,
                repeat: -1
            })
            grass3.setPosition(grass3_coordinates[i][0] + (grass3.width * (grass3.originX - 0.5)), grass3_coordinates[i][1] + (grass3.height * (grass3.originY - 0.5)));
            grass3.depth = grass3.y
            grass3.play('grass3_animate')
        }

        let grass4_coordinates = [[7629, 3448]]

        for (var i = 0; i < grass4_coordinates.length; i++) {
            var grass4 = this.add.sprite(0, 0, 'grass4', 'ground').setScale(1)
            this.anims.create({
                key: "grass4_animate",
                frames: this.anims.generateFrameNumbers("grass4"),
                frameRate: 20,
                repeat: -1
            })
            grass4.setPosition(grass4_coordinates[i][0] + (grass4.width * (grass4.originX - 0.5)), grass4_coordinates[i][1] + (grass4.height * (grass4.originY - 0.5)));
            grass4.depth = grass4.y
            grass4.play('grass4_animate')
        }

        let grass5_coordinates = [[2186, 5668], [5589, 2936], [8183, 3181], [8916, 3010], [10304, 5787],]

        for (var i = 0; i < grass5_coordinates.length; i++) {
            var grass5 = this.add.sprite(0, 0, 'grass5', 'ground').setScale(1)
            this.anims.create({
                key: "grass5_animate",
                frames: this.anims.generateFrameNumbers("grass4"),
                frameRate: 20,
                repeat: -1
            })
            grass5.setPosition(grass5_coordinates[i][0] + (grass5.width * (grass5.originX - 0.5)), grass5_coordinates[i][1] + (grass5.height * (grass5.originY - 0.5)));
            grass5.depth = grass5.y
            grass5.play('grass5_animate')
        }

        let grass7_coordinates = [[3021, 5761], [2901, 3616], [3026, 3430], [3593, 3067]]

        for (var i = 0; i < grass7_coordinates.length; i++) {
            var grass7 = this.add.sprite(0, 0, 'grass7', 'ground').setScale(1)
            this.anims.create({
                key: "grass7_animate",
                frames: this.anims.generateFrameNumbers("grass7"),
                frameRate: 20,
                repeat: -1
            })
            grass7.setPosition(grass7_coordinates[i][0] + (grass7.width * (grass7.originX - 0.5)), grass7_coordinates[i][1] + (grass7.height * (grass7.originY - 0.5)));
            grass7.depth = grass7.y
            grass7.play('grass7_animate')
        }

        let rock1_coordinates = [[11264, 6136], [10284, 5441], [2757, 7944], [1985, 5056]]

        for (var i = 0; i < rock1_coordinates.length; i++) {
            var rock_1 = this.matter.add.image(0, 0, 'rock1', 'ground', { shape: props1_shapes._0040_rock_1 }).setScale(1);
            rock_1.setPosition(rock1_coordinates[i][0] + (rock_1.width * (rock_1.originX - 0.5)), rock1_coordinates[i][1] + (rock_1.height * (rock_1.originY - 0.5)));
            rock_1.depth = rock_1.y
            rock_1.setCollisionCategory(category3);
            rock_1.setCollidesWith(category4);
        }

        let rock2_coordinates = [[9044, 8107], [3180, 8196], [3069, 5517], [4034, 5364]]

        for (var i = 0; i < rock2_coordinates.length; i++) {
            var rock_2 = this.matter.add.image(0, 0, 'rock2', 'ground', { shape: props1_shapes._0041_rock_2 }).setScale(1);
            rock_2.setPosition(rock2_coordinates[i][0] + (rock_2.width * (rock_2.originX - 0.5)), rock2_coordinates[i][1] + (rock_2.height * (rock_2.originY - 0.5)));
            rock_2.depth = rock_1.y
            rock_2.setCollisionCategory(category3);
            rock_2.setCollidesWith(category4);
        }

        let rock3_coordinates = [[7077, 9007], [5071, 8880], [3795, 5173]]

        for (var i = 0; i < rock3_coordinates.length; i++) {
            var rock_3 = this.matter.add.image(0, 0, 'rock3', 'ground', { shape: props1_shapes._0042_rock_3 }).setScale(1);
            rock_3.setPosition(rock3_coordinates[i][0] + (rock_3.width * (rock_3.originX - 0.5)), rock3_coordinates[i][1] + (rock_3.height * (rock_3.originY - 0.5)));
            rock_3.depth = rock_3.y
            rock_3.setCollisionCategory(category3);
            rock_3.setCollidesWith(category4);
        }

        let rock4_coordinates = [[7274, 9149], [4955, 9029], [3325, 8117], [3978, 5441]]

        for (var i = 0; i < rock4_coordinates.length; i++) {
            var rock_4 = this.matter.add.image(0, 0, 'rock4', 'ground', { shape: props1_shapes._0043_rock_4 }).setScale(1);
            rock_4.setPosition(rock4_coordinates[i][0] + (rock_4.width * (rock_4.originX - 0.5)), rock4_coordinates[i][1] + (rock_4.height * (rock_4.originY - 0.5)));
            rock_4.depth = rock_4.y
            rock_4.setCollisionCategory(category3);
            rock_4.setCollidesWith(category4);
        }

        let rock5_coordinates = [[11130, 6213], [1906, 5144]]

        for (var i = 0; i < rock5_coordinates.length; i++) {
            var rock_5 = this.matter.add.image(0, 0, 'rock4', 'ground', { shape: props1_shapes._0044_rock_5 }).setScale(1);
            rock_5.setPosition(rock5_coordinates[i][0] + (rock_5.width * (rock_5.originX - 0.5)), rock5_coordinates[i][1] + (rock_5.height * (rock_5.originY - 0.5)));
            rock_5.depth = rock_5.y
            rock_5.setCollisionCategory(category3);
            rock_5.setCollidesWith(category4);
        }

        //    let sand1_coordinates = [[7242, 4093],[6462, 5725],[4885, 8185]]

        //    for (var i = 0; i < sand1_coordinates.length; i++)
        //    {
        //        var sand_1 = this.add.image(0, 0, 'sand1').setScale(1);
        //        sand_1.setPosition(sand1_coordinates[i][0]+(sand_1.width*(sand_1.originX-0.5)), sand1_coordinates[i][1]+(sand_1.height*(sand_1.originY-0.5)));
        //        sand_1.depth = sand_1.y-500
        //    }

        //    let sand2_coordinates = [[6859, 8702]]

        //    for (var i = 0; i < sand2_coordinates.length; i++)
        //    {
        //        var sand_2 = this.add.image(0, 0, 'sand2').setScale(1);
        //        sand_2.setPosition(sand2_coordinates[i][0]+(sand_2.width*(sand_2.originX-0.5)), sand2_coordinates[i][1]+(sand_2.height*(sand_2.originY-0.5)));
        //        sand_2.depth = sand_2.y-500
        //    }

        let rockpath1_coordinates = []

        for (var i = 0; i < rockpath1_coordinates.length; i++) {
            var rockpath_1 = this.matter.add.image(0, 0, 'rockpath1', 'ground', { shape: props1_shapes._0047_rockpath_1 }).setScale(1);
            rockpath_1.setPosition(rockpath1_coordinates[i][0] + (rockpath_1.width * (rockpath_1.originX - 0.5)), rockpath1_coordinates[i][1] + (rockpath_1.height * (rockpath_1.originY - 0.5)));
            rockpath_1.depth = rockpath_1.y - 200
            rockpath_1.setCollisionCategory(category3);
            rockpath_1.setCollidesWith(category4);
        }

        //    let rockpath2_coordinates = [[4959, 7918],[8073, 5789]]

        //    for (var i = 0; i < rockpath2_coordinates.length; i++)
        //    {
        //        var rockpath_2 = this.add.image(0, 0, 'rockpath2', 'ground').setScale(1);
        //        rockpath_2.setPosition(rockpath2_coordinates[i][0]+(rockpath_2.width*(rockpath_2.originX-0.5)), rockpath2_coordinates[i][1]+(rockpath_2.height*(rockpath_2.originY-0.5)));
        //        rockpath_2.depth = rockpath_2.y-500
        //    }

        //    let rock6_coordinates = [[1038, 6280]]

        //    for (var i = 0; i < rock6_coordinates.length; i++)
        //    {
        //        var rock_6 = this.matter.add.image(0, 0, 'rock6', 'ground', {shape: props1_shapes._0049_rock_6}).setScale(1);
        //        rock_6.setPosition(rock6_coordinates[i][0]+(rock_6.width*(rock_6.originX-0.5)), rock6_coordinates[i][1]+(rock_6.height*(rock_6.originY-0.5)));
        //        rock_6.depth = rock_6.y
        //        rock_6.setCollisionCategory(category3);
        //        rock_6.setCollidesWith(category4);
        //    }


        let rock7_coordinates = []

        for (var i = 0; i < rock7_coordinates.length; i++) {
            var rock_7 = this.matter.add.image(0, 0, 'rock7', 'ground', { shape: props1_shapes._0050_rock_7 }).setScale(1);
            rock_7.setPosition(rock7_coordinates[i][0] + (rock_7.width * (rock_7.originX - 0.5)), rock7_coordinates[i][1] + (rock_7.height * (rock_7.originY - 0.5)));
            rock_7.depth = rock_7.y
            rock_7.setCollisionCategory(category3);
            rock_7.setCollidesWith(category4);
        }

        let rock8_coordinates = [[1297, 5466]]

        for (var i = 0; i < rock8_coordinates.length; i++) {
            var rock_8 = this.matter.add.image(0, 0, 'rock8', 'ground', { shape: props1_shapes._0051_rock_8 }).setScale(1);
            rock_8.setPosition(rock8_coordinates[i][0] + (rock_8.width * (rock_8.originX - 0.5)), rock8_coordinates[i][1] + (rock_8.height * (rock_8.originY - 0.5)));
            rock_8.depth = rock_8.y
            rock_8.setCollisionCategory(category3);
            rock_8.setCollidesWith(category4);
        }

        //    let rock9_coordinates = [[1871, 7638]]

        //    for (var i = 0; i < rock9_coordinates.length; i++)
        //    {
        //        var rock_9 = this.matter.add.image(0, 0, 'rock9', 'ground', {shape: props1_shapes._0052_rock_9}).setScale(1);
        //        rock_9.setPosition(rock9_coordinates[i][0]+(rock_9.width*(rock_9.originX-0.5)), rock9_coordinates[i][1]+(rock_9.height*(rock_9.originY-0.5)));
        //        rock_9.depth = rock_9.y
        //        rock_9.setCollisionCategory(category3);
        //        rock_9.setCollidesWith(category4);
        //    }   

        let rock10_coordinates = [[2037, 6902]]

        for (var i = 0; i < rock10_coordinates.length; i++) {
            var rock_10 = this.matter.add.image(0, 0, 'rock10', 'ground', { shape: props1_shapes._0053_rock_10 }).setScale(1);
            rock_10.setPosition(rock10_coordinates[i][0] + (rock_10.width * (rock_10.originX - 0.5)), rock10_coordinates[i][1] + (rock_10.height * (rock_10.originY - 0.5)));
            rock_10.depth = rock_10.y
            rock_10.setCollisionCategory(category3);
            rock_10.setCollidesWith(category4);
        }

        let chair1_coordinates = [[7091, 6845]]

        for (var i = 0; i < chair1_coordinates.length; i++) {
            var chair_1 = this.matter.add.image(0, 0, 'chair1', 'ground', { shape: props1_shapes._0054_chair_1 }).setScale(1);
            chair_1.setPosition(chair1_coordinates[i][0] + (chair_1.width * (chair_1.originX - 0.5)), chair1_coordinates[i][1] + (chair_1.height * (chair_1.originY - 0.5)));
            chair_1.depth = chair_1.y
            chair_1.setCollisionCategory(category3);
            chair_1.setCollidesWith(category4);
        }

        let chair2_coordinates = []
        for (var i = 0; i < chair2_coordinates.length; i++) {
            var chair_2 = this.matter.add.image(0, 0, 'chair2', 'ground', { shape: props1_shapes._0055_chair_2 }).setScale(1);
            chair_2.setPosition(chair2_coordinates[i][0] + (chair_2.width * (chair_2.originX - 0.5)), chair2_coordinates[i][1] + (chair_2.height * (chair_2.originY - 0.5)));
            chair_2.depth = chair_2.y
            chair_2.setCollisionCategory(category3);
            chair_2.setCollidesWith(category4);
        }

        let barrel_coordinates = [[7512, 2681], [7803, 2652], [7689, 2548]]

        for (var i = 0; i < barrel_coordinates.length; i++) {
            var barrel = this.matter.add.image(0, 0, 'barrel', 'ground', { shape: props1_shapes._0056_barrel }).setScale(1);
            barrel.setPosition(barrel_coordinates[i][0] + (barrel.width * (barrel.originX - 0.5)), barrel_coordinates[i][1] + (barrel.height * (barrel.originY - 0.5)));
            barrel.depth = barrel.y
            barrel.setCollisionCategory(category3);
            barrel.setCollidesWith(category4);
        }

        let whiteflowerbush_coordinates = [[8431, 4177], [8751, 4774], [8595, 4829], [5013, 3701], [4573, 3263], [4155, 4481], [4008, 4583], [3789, 4844], [5230, 7209], [5060, 7165], [5402, 7005], [5131, 6981], [5267, 6895], [4967, 6717], [6360, 9519], [6911, 9452], [7485, 10076], [7908, 9933], [8682, 9614], [9032, 9747], [9380, 9552], [2753, 7441]]

        for (var i = 0; i < whiteflowerbush_coordinates.length; i++) {
            var whiteflowerbush = this.add.image(0, 0, 'whiteflowerbush').setScale(1);
            whiteflowerbush.setPosition(whiteflowerbush_coordinates[i][0] + (whiteflowerbush.width * (whiteflowerbush.originX - 0.5)), whiteflowerbush_coordinates[i][1] + (whiteflowerbush.height * (whiteflowerbush.originY - 0.5)));
            whiteflowerbush.depth = whiteflowerbush.y + 100
        }


        let fence3_coordinates = [[5607, 4104], [5910, 4103]]

        for (var i = 0; i < fence3_coordinates.length; i++) {
            var fence_3 = this.matter.add.image(0, 0, 'fence3', 'ground', { shape: props1_shapes._0058_fence_3 }).setScale(1);
            fence_3.setPosition(fence3_coordinates[i][0] + (fence_3.width * (fence_3.originX - 0.5)), fence3_coordinates[i][1] + (fence_3.height * (fence_3.originY - 0.5)));
            fence_3.depth = fence_3.y
            fence_3.setCollisionCategory(category3);
            fence_3.setCollidesWith(category4);
        }

        let stall1_coordinates = [[7143, 8443]]

        for (var i = 0; i < stall1_coordinates.length; i++) {
            var stall_1 = this.matter.add.image(0, 0, 'stall1', 'ground', { shape: props1_shapes._0059_stall_1 }).setScale(1);
            stall_1.setPosition(stall1_coordinates[i][0] + (stall_1.width * (stall_1.originX - 0.5)), stall1_coordinates[i][1] + (stall_1.height * (stall_1.originY - 0.5)));
            stall_1.depth = stall_1.y
            stall_1.setCollisionCategory(category3);
            stall_1.setCollidesWith(category4);
        }

        let stall2_coordinates = [[8566, 8453]]

        for (var i = 0; i < stall2_coordinates.length; i++) {
            var stall_2 = this.matter.add.image(0, 0, 'stall2', 'ground', { shape: props1_shapes._0060_stall_2 }).setScale(-1, 1);
            //stall_2.flipX = true
            stall_2.setPosition(stall2_coordinates[i][0] + (stall_2.width * (stall_2.originX - 0.5)), stall2_coordinates[i][1] + (stall_2.height * (stall_2.originY - 0.5)));
            stall_2.depth = stall_2.y
            stall_2.setCollisionCategory(category3);
            stall_2.setCollidesWith(category4);

        }

        let log_coordinates = [[7678, 6071]]

        for (var i = 0; i < log_coordinates.length; i++) {
            var log = this.matter.add.image(0, 0, 'log', 'ground', { shape: props1_shapes._0061_log }).setScale(1);
            log.setPosition(log_coordinates[i][0] + (log.width * (log.originX - 0.5)), log_coordinates[i][1] + (log.height * (log.originY - 0.5)));
            log.depth = log.y - 150
            log.setCollisionCategory(category3);
            log.setCollidesWith(category4);
        }

        let whiteflower_coordinates = [[4631, 4862], [4724, 4915], [4803, 4815]]

        for (var i = 0; i < whiteflower_coordinates.length; i++) {
            var whiteflower = this.add.sprite(0, 0, 'whiteflower', 'ground').setScale(1)
            this.anims.create({
                key: "whiteflower_animate",
                frames: this.anims.generateFrameNumbers("whiteflower"),
                frameRate: 20,
                repeat: -1
            })
            whiteflower.setPosition(whiteflower_coordinates[i][0] + 20 + (whiteflower.width * (whiteflower.originX - 0.5)), whiteflower_coordinates[i][1] + (whiteflower.height * (whiteflower.originY - 0.5)));
            whiteflower.depth = whiteflower.y + 30
            whiteflower.play('whiteflower_animate')
        }

        //    var pinkcarrot = this.add.image(0,0,'pinkcarrot')
        //    var pinkcarrot_collision = this.matter.add.image(0, 0, 'pinkcarrot', 'ground', {shape: props1_shapes._0030_pinkcarrot}).setScale(1);
        //    pinkcarrot.setPosition(pinkcarrot_coordinates[i][0]-370+(pinkcarrot.width-pinkcarrot.displayOriginX), pinkcarrot_coordinates[i][1]+620+(whiteflower.height*(whiteflower.originY-0.5));
        //    pinkcarrot_collision.setPosition(pinkcarrot_coordinates[i][0]-370+(pinkcarrot.width-pinkcarrot.displayOriginX), pinkcarrot_coordinates[i][1]+570+(pinkcarrot.width-pinkcarrot.displayOriginY));
        //    pinkcarrot.depth = pinkcarrot.y
        //    pinkcarrot_collision.setCollisionCategory(category3);
        //    pinkcarrot_collision.setCollidesWith(category4);

        let blueflower_coordinates = [[9051, 5356], [8799, 5234], [8652, 5292], [10013, 5940], [10098, 5773], [9839, 5781], [9942, 5684], [9740, 5634]]

        for (var i = 0; i < blueflower_coordinates.length; i++) {
            var blueflower = this.add.sprite(0, 0, 'blueflower').setScale(1)
            this.anims.create({
                key: "blueflower_animate",
                //frames: this.anims.generateFrameNumbers("blueflower"),
                frames: this.anims.generateFrameNumbers('blueflower', { start: 0, end: 39, first: 39 }),
                frameRate: 20,
                repeat: -1
            })
            blueflower.setPosition(blueflower_coordinates[i][0] + (blueflower.width * (blueflower.originX - 0.5)), blueflower_coordinates[i][1] + (blueflower.height * (blueflower.originY - 0.5)));
            blueflower.depth = blueflower.y
            blueflower.play('blueflower_animate')
        }


        let yellowflower_coordinates = [[9661, 5728], [9661, 5728], [9778, 5845], [9977, 5752], [8930, 5432], [8951, 5310], [8777, 5348], [8687, 5221]]

        for (var i = 0; i < yellowflower_coordinates.length; i++) {
            var yellowflower = this.add.sprite(0, 0, 'yellowflower').setScale(1)
            this.anims.create({
                key: "yellowflower_animate",
                frames: this.anims.generateFrameNumbers("yellowflower"),
                frameRate: 20,
                repeat: -1
            })
            yellowflower.setPosition(yellowflower_coordinates[i][0] + (yellowflower.width * (yellowflower.originX - 0.5)), yellowflower_coordinates[i][1] + (yellowflower.height * (yellowflower.originY - 0.5)));
            yellowflower.depth = yellowflower.y + 20
            yellowflower.play('yellowflower_animate')
        }

        let yellowflowerpot_coordinates = [[9757, 6112], [9603, 6039], [8694, 5584], [8541, 5511], [8387, 5444]]

        for (var i = 0; i < yellowflowerpot_coordinates.length; i++) {
            var yellowflowerpot = this.matter.add.image(0, 0, 'yellowflowerpot', 'ground', { shape: props1_shapes._0065_yellowflowerpot }).setScale(1);
            yellowflowerpot.setPosition(yellowflowerpot_coordinates[i][0] + (yellowflowerpot.width * (yellowflowerpot.originX - 0.5)), yellowflowerpot_coordinates[i][1] + (yellowflowerpot.height * (yellowflowerpot.originY - 0.5)));
            yellowflowerpot.depth = yellowflowerpot.y + 65
            yellowflowerpot.setCollisionCategory(category3);
            yellowflowerpot.setCollidesWith(category4);
        }

        let redflowerpot_coordinates = [[9833, 6149], [9681, 6076], [9524, 6003], [8614, 5551], [8466, 5477]]

        for (var i = 0; i < redflowerpot_coordinates.length; i++) {
            var redflowerpot = this.matter.add.image(0, 0, 'redflowerpot', 'ground', { shape: props1_shapes._0066_redflowerpot }).setScale(1);
            redflowerpot.setPosition(redflowerpot_coordinates[i][0] + (redflowerpot.width * (redflowerpot.originX - 0.5)), redflowerpot_coordinates[i][1] + (redflowerpot.height * (redflowerpot.originY - 0.5)));
            redflowerpot.depth = redflowerpot.y + 65
            redflowerpot.setCollisionCategory(category3);
            redflowerpot.setCollidesWith(category4);
        }

        let redflowerbush_coordinates = [[10129, 5678], [9932, 5605], [10243, 5579], [10073, 5511], [8988, 5227], [9103, 5128], [8791, 5156], [8934, 5062], [10242, 7926], [10508, 7826]]

        for (var i = 0; i < redflowerbush_coordinates.length; i++) {
            var redflowerbush = this.add.image(0, 0, 'redflowerbush').setScale(1);
            redflowerbush.setPosition(redflowerbush_coordinates[i][0] + (redflowerbush.width * (redflowerbush.originX - 0.5)), redflowerbush_coordinates[i][1] + (redflowerbush.height * (redflowerbush.originY - 0.5)));
            redflowerbush.depth = redflowerbush.y + 65
        }

        let rockcircle_coordinates = [[7894, 8176]]

        for (var i = 0; i < rockcircle_coordinates.length; i++) {
            var rockcircle = this.add.image(0, 0, 'rockcircle').setScale(1);
            rockcircle.setPosition(rockcircle_coordinates[i][0] + (rockcircle.width * (rockcircle.originX - 0.5)), rockcircle_coordinates[i][1] + (rockcircle.height * (rockcircle.originY - 0.5)));
            rockcircle.depth = rockcircle.y
            rockcircle.depth = rockcircle.y - 2000
        }

        let fountain_coordinates = [[6103, 4963]]

        for (var i = 0; i < fountain_coordinates.length; i++)
        //    {
        //        var fountain = this.matter.add.image(0, 0, 'fountain', 'ground', {shape: props1_shapes._0070_fountain, label: "Fountain"}).setScale(1);
        //        fountain.setPosition(fountain_coordinates[i][0]+(fountain.width*(fountain.originX-0.5)), fountain_coordinates[i][1]+(fountain.height*(fountain.originY-0.5)));
        //        fountain.depth = fountain.y
        //        fountain.setCollisionCategory(category3);
        //        fountain.setCollidesWith(category4);
        //    }

        {
            var fountain = this.matter.add.sprite(0, 0, 'fountain', 'ground', { shape: props1_shapes._0070_fountain }).setScale(1)
            this.anims.create({
                key: "fountain_animate",
                frames: this.anims.generateFrameNumbers("fountain"),
                frameRate: 20,
                repeat: -1
            })
            fountain.setPosition(fountain_coordinates[i][0] + (fountain.width * (fountain.originX - 0.5)), fountain_coordinates[i][1] + (fountain.height * (fountain.originY - 0.5)));
            fountain.depth = fountain.y
            fountain.play('fountain_animate')
            fountain.setCollisionCategory(category3);
            fountain.setCollidesWith(category4);
        }

        let egg_coordinates = [[6225, 9075], [9500, 2108]]

        for (var i = 0; i < egg_coordinates.length; i++) {
            var egg = this.add.sprite(0, 0, 'egg').setScale(1)
            this.anims.create({
                key: "egg_animate",
                frames: this.anims.generateFrameNumbers("egg"),
                frameRate: 20,
                repeat: -1
            })
            egg.setPosition(egg_coordinates[i][0] + (egg.width * (egg.originX - 0.5)) + 175, egg_coordinates[i][1] + (egg.height * (egg.originY - 0.5)));
            egg.depth = egg.y + 1000
            egg.play('egg_animate')
        }

        //    var blueflower = this.add.image(0, 0, 'blueflower').setScale(1);
        //    blueflower.setPosition(blueflower_coordinates[i][0]-25+(blueflower.width-blueflower.displayOriginX), blueflower_coordinates[i][1]+60+(blueflower.width-blueflower.displayOriginY));
        //    blueflower.depth = blueflower.y+50
        let purplehouse1_coordinates = [[8424, 3421]]

        for (var i = 0; i < purplehouse1_coordinates.length; i++) {
            var purplehouse_1 = this.matter.add.image(0, 0, 'purplehouse_1', 'ground', { shape: props1_shapes._0072_purplehouse_1 }).setScale(-1, 1);
            purplehouse_1.setPosition(purplehouse1_coordinates[i][0] + (purplehouse_1.width * (purplehouse_1.originX - 0.5)), purplehouse1_coordinates[i][1] + (purplehouse_1.height * (purplehouse_1.originY - 0.5)));
            purplehouse_1.depth = purplehouse_1.y
            purplehouse_1.setCollisionCategory(category3);
            purplehouse_1.setCollidesWith(category4);
        }

        let purplehouse2_coordinates = [[7614, 9650]]

        for (var i = 0; i < purplehouse2_coordinates.length; i++) {
            var purplehouse_2 = this.matter.add.image(0, 0, 'purplehouse_2', 'ground', { shape: props1_shapes._0073_purplehouse_2 }).setScale(1);
            purplehouse_2.setPosition(purplehouse2_coordinates[i][0] + (purplehouse_2.width * (purplehouse_2.originX - 0.5)), purplehouse2_coordinates[i][1] + (purplehouse_2.height * (purplehouse_2.originY - 0.5)));
            purplehouse_2.depth = purplehouse_2.y
            purplehouse_2.setCollisionCategory(category3);
            purplehouse_2.setCollidesWith(category4);
        }

        let redhouse1_coordinates = [[9489, 2252], [2409, 5317]]

        for (var i = 0; i < redhouse1_coordinates.length; i++) {
            var redhouse_1 = this.matter.add.image(0, 0, 'redhouse_1', 'ground', { shape: props1_shapes._0074_redhouse_1 }).setScale(-1, 1);
            redhouse_1.setPosition(redhouse1_coordinates[i][0] + (redhouse_1.width * (redhouse_1.originX - 0.5)), redhouse1_coordinates[i][1] + (redhouse_1.height * (redhouse_1.originY - 0.5)));
            redhouse_1.depth = redhouse_1.y - 1000
            redhouse_1.setCollisionCategory(category3);
            redhouse_1.setCollidesWith(category4);
        }

        let redhouse2_coordinates = [[6534, 9157]]

        for (var i = 0; i < redhouse2_coordinates.length; i++) {
            var redhouse_2 = this.matter.add.image(0, 0, 'redhouse_2', 'ground', { shape: props1_shapes._0075_redhouse_2 }).setScale(1);
            redhouse_2.setPosition(redhouse2_coordinates[i][0] + (redhouse_2.width * (redhouse_2.originX - 0.5)), redhouse2_coordinates[i][1] + (redhouse_2.height * (redhouse_2.originY - 0.5)));
            redhouse_2.depth = redhouse_2.y
            redhouse_2.setCollisionCategory(category3);
            redhouse_2.setCollidesWith(category4);
        }

        let bluehouse1_coordinates = [[7147, 2275]]

        for (var i = 0; i < bluehouse1_coordinates.length; i++) {
            var bluehouse_1 = this.matter.add.image(0, 0, 'bluehouse_1', 'ground', { shape: props1_shapes._0076_bluehouse_1 }).setScale(1);
            bluehouse_1.setPosition(bluehouse1_coordinates[i][0] + (bluehouse_1.width * (bluehouse_1.originX - 0.5)), bluehouse1_coordinates[i][1] + (bluehouse_1.height * (bluehouse_1.originY - 0.5)));
            bluehouse_1.depth = bluehouse_1.y
            bluehouse_1.setCollisionCategory(category3);
            bluehouse_1.setCollidesWith(category4);
        }

        let bluehouse2_coordinates = [[8990, 9177]]

        for (var i = 0; i < bluehouse2_coordinates.length; i++) {
            var bluehouse_2 = this.matter.add.image(0, 0, 'bluehouse_2', 'ground', { shape: props1_shapes._0077_bluehouse_2 }).setScale(1);
            bluehouse_2.setPosition(bluehouse2_coordinates[i][0] + (bluehouse_2.width * (bluehouse_2.originX - 0.5)), bluehouse2_coordinates[i][1] + (bluehouse_2.height * (bluehouse_2.originY - 0.5)));
            bluehouse_2.depth = bluehouse_2.y
        }

        let pumpkin_coordinates = [[10933, 5791], [7682, 3147]]

        for (var i = 0; i < pumpkin_coordinates.length; i++) {
            var pumpkin = this.matter.add.image(0, 0, 'pumpkin', 'ground', { shape: props1_shapes._0078_pumpkin }).setScale(-1, 1);
            pumpkin.setPosition(pumpkin_coordinates[i][0] + (pumpkin.width * (pumpkin.originX - 0.5)), pumpkin_coordinates[i][1] + (pumpkin.height * (pumpkin.originY - 0.5)));
            pumpkin.depth = pumpkin.y
        }

        //    let rock11_coordinates = [[11996, 7986],[10331, 9762]]

        //    for (var i = 0; i < rock11_coordinates.length; i++)
        //    {
        //        var rock_11 = this.matter.add.image(0, 0, 'rock11', 'ground', {shape: props1_shapes._0079_rock_11}).setScale(1);
        //        rock_11.setPosition(rock11_coordinates[i][0]+(rock_11.width*(rock_11.originX-0.5)), rock11_coordinates[i][1]+(rock_11.height*(rock_11.originY-0.5)));
        //        rock_11.depth = rock_11.y
        //        rock_11.setCollisionCategory(category3);
        //        rock_11.setCollidesWith(category4);
        //    }

        //    let rock12_coordinates = [[1998, 3512],[10841, 9411]]

        //    for (var i = 0; i < rock12_coordinates.length; i++)
        //    {
        //        var rock_12 = this.matter.add.image(0, 0, 'rock12', 'ground', {shape: props1_shapes._0080_rock_12}).setScale(1);
        //        rock_12.setPosition(rock12_coordinates[i][0]+(rock_12.width*(rock_12.originX-0.5)), rock12_coordinates[i][1]+(rock_12.height*(rock_12.originY-0.5)));
        //        rock_12.depth = rock_12.y
        //        if(i==1){
        //            rock_12.setScale(-2,2)

        //        }
        //        rock_12.setCollisionCategory(category3);
        //        rock_12.setCollidesWith(category4);
        //    }

        //    let rock13_coordinates = [[1198, 3388],[2834, 9423]]

        //    for (var i = 0; i < rock13_coordinates.length; i++)
        //    {
        //        var rock_13 = this.matter.add.image(0, 0, 'rock13', 'ground', {shape: props1_shapes._0081_rock_13}).setScale(1.5);
        //        rock_13.setPosition(rock13_coordinates[i][0]+(rock_13.width*(rock_13.originX-0.5)), rock13_coordinates[i][1]+(rock_13.height*(rock_13.originY-0.5)));
        //        rock_13.depth = rock_13.y
        //        rock_13.setCollisionCategory(category3);
        //        rock_13.setCollidesWith(category4);
        //    }


        let log2_coordinates = [[4478, 6970]]

        for (var i = 0; i < log2_coordinates.length; i++) {
            var log_2 = this.matter.add.image(0, 0, 'log2', 'ground', { shape: props1_shapes._0082_log_2 }).setScale(-1, 1);
            log_2.setPosition(log2_coordinates[i][0] + (log_2.width * (log_2.originX - 0.5)), log2_coordinates[i][1] + (log_2.height * (log_2.originY - 0.5)));
            log_2.depth = log_2.y
            log_2.setCollisionCategory(category3);
            log_2.setCollidesWith(category4);
        }

        let x_icon_coordinates = [[5789, 3920]]



        let x_icon = this.add.sprite(0, 0, 'x_icon').setScale(1)

        this.anims.create({

            key: "xicon_animate",

            frames: this.anims.generateFrameNumbers("x_icon"),

            frameRate: 20,

            repeat: -1

        })

        x_icon.setPosition(5889 + (x_icon.width), 3920 + (x_icon.height * (x_icon.originY - 0.5)));

        x_icon.depth = x_icon.y + 90

        x_icon.play('xicon_animate')


        //
        //NPC Section
        //

        npcChief = this.add.spine(5989, 4320, 'chief', 'Idle', true)
        npcChief.setScale(0.5)
        npcChief.depth = npcChief.y + 100

        npcFarmer = this.add.spine(4367, 7426, 'farmer', 'Idle', true)
        npcFarmer.setScale(0.5)
        npcFarmer.depth = npcFarmer.y + 300

        npcKnight = this.add.spine(7343, 8043, 'knight', 'Idle', true)
        npcKnight.setScale(0.6)
        npcKnight.depth = npcKnight.y + 100
        //    var npcChief = this.add.image(5989,4320,'chief').setScale(0.5)
        //    npcChief.depth = npcChief.y + 500

        //
        //Player Set Layers Section
        //
        playerLocal = this.add.spine(playerX, playerY, 'boy', 'run', true)
        playerLocalFur = this.add.spine(playerX, playerY, 'boy', 'run', true)
        //let [playerLocal,playerLocalFur] = createPlayer(this,'boy','run')
        playerLocal.setScale(0.5)
        playerLocalFur.setScale(0.5)
        setAttachmentFull(playerLocal, playerLocalFur, wearingList)
        strWearingList = JSON.stringify(wearingList, replacer);

        // for (let i = 0; i < 20; i++) {
        // let    playerOther = this.add.spine(playerX+(100*i),playerY+(100*i),'boy','run',true) 
        //     playerOther.setScale(0.5)
        //     setAttachmentFull(playerOther,testAttributeList)
        //   }
        // var bodies = Phaser.Physics.Matter.Matter.Bodies;
        // var bodyCollision = bodies.circle(playerX, playerY+100, 24, { isSensor: false, label: 'playerCollision' });
        // var bodySensor = bodies.circle(playerX, playerY, 250, { isSensor: true, label: 'playerSensor' });

        // var compoundBody = Phaser.Physics.Matter.Matter.Body.create({
        //     parts: [ bodyCollision, bodySensor ],
        //     inertia: Infinity
        // });



        player = this.matter.add.image(playerX, playerY, 'empty_image'
        ).setScale(0.8, 0.4);
        //let player2 = this.matter.add.image(playerX, playerY, 'empty_image')
        // player.setExistingBody(compoundBody);
        player.setBody({
            type: 'circle',
            radius: 36
        });
        player.setFriction(0.2, 0.3, 0.2);
        player.setOrigin(1, 1)
        player.setFixedRotation();
        player.setCollisionCategory(category4);
        player.setCollidesWith(category3);
        //player.fillOpacity = 0;
        //player.setPosition(playerX,playerY, 0);
        //player.visble = false;
        // player.setFriction(1)
        // player.setFrictionStatic(10)
        //player.setFrictionAir(10)

        this.cameras.main.startFollow(player, true);
        this.cameras.main.setZoom(0.27)
        this.cameras.main.setBounds(0, 0, 12877, 10949)

        this.dialogManager = new DialogManager(
            this,
            playerLocal,
            "playerLocal"
        );

        this.dialogManager.addNPC(npcChief, "npcChief")
        this.dialogManager.addNPC(npcFarmer, "npcFarmer")
        this.dialogManager.addNPC(npcKnight, "npcKnight")

        elementChracterName = this.add.dom(playerX + playerPaddingX, playerY + playerPaddingY).createFromCache('nameHtml');
        elementChracterName.getChildByName().querySelectorAll('[name="ui--character-name"]')[0].innerText = userName


        keys = this.input.keyboard.addKeys("W,A,S,D,X,C,P,V,B");

        this.input.keyboard.on('keydown', function (event) {
            let controlKey = ["w", "a", "s", "d", "x", "c", "p", "v", "b"];
            if (document.activeElement.tagName === "INPUT") {
                if (controlKey.includes(event.key)) {
                    input.value = input.value + event.key
                }
            }
        })

        // $.get(`${externalHost}getBannerInfo`, function(data, status){
        //     let receiveData = JSON.parse(data);
        //     if (receiveData.isShow) {

        //      let currentDate =  new Date();
        //      let isShowBanner = false;
        //      let startShowBannerDate = new Date(receiveData.startDate);

        //     let topBannerInterval =  setInterval(() => {
        //         currentDate =  new Date();

        //          if (currentDate > startShowBannerDate) {
        //             let topBannerHtml = `<div  id="topBanner" class="top-banner__wrapper">
        //                 <div class="top-banner__body">
        //                     <img src="${externalHost}${receiveData.imgUrl}">
        //                 </div>
        //                 <div id="topBannerSwitch" class="top-banner__switch"><img src="${externalHost}assets/icons/icon_arrow_left.png"></div>
        //             </div>`;
        //         $('body').append(topBannerHtml);

        //         let topBanner = $("#topBanner");
        //         setTimeout(() => {
        //             topBanner.addClass("show");
        //         }, 800);


        //         $("#topBannerSwitch").on("click",function() {
        //             if (topBanner[0].className.includes("show")) {
        //                 topBanner.removeClass("show")
        //             } else {
        //                 topBanner.addClass("show")
        //             }
        //         })
        //             clearInterval(topBannerInterval)
        //          }
        //      }, 1000);

        //     }
        //   });


        this.bgMusic = this.sound.add('bgMusic', { volume: 0.5, loop: true });
        this.bgMusic.play();
        window.initInventory(visualItemInventory,wearingList)
        $('.inventory-right__items-child__close').on("click",function(){

            let data = window.changingClothesObj;

            UnEquip(data.attrList.items,data.attrList.attrKey,playerLocal,playerLocalFur,wearingList)

                strWearingList = JSON.stringify(wearingList, replacer);

                if (typeof socket !== "undefined"){

                    socket.emit('update', {

                        action: "Cloth Change",

                        userName: userName,

                        position: { x: player.x, y: player.y },

                        scale: playerLocal.scale,

                        foxId: 2,

                        room: selectedRoom,

                        item: data.attrList.items,

                        item2: data.attrList.attrKey,

                        attribute: strWearingList,

                        equip: false

                    });

                }



        })

        $('.inventory-right__items-child').on("click", function(){

            let data = window.changingClothesObj;

            if(data.attrList.isWear){

                Equip(data.attrList.items,data.attrList.attrKey,playerLocal,playerLocalFur,wearingList)

                strWearingList = JSON.stringify(wearingList, replacer);

                if (typeof socket !== "undefined"){

                    socket.emit('update', {

                        action: "Cloth Change",

                        userName: userName,

                        position: { x: player.x, y: player.y },

                        scale: playerLocal.scale,

                        foxId: 2,

                        room: selectedRoom,

                        item: data.attrList.items,

                        item2: data.attrList.attrKey,

                        attribute: strWearingList,

                        equip: true

                    });

                }

            }

        })

        this.game.scale.setGameSize(window.innerWidth / 1.5, window.innerHeight / 1.5)

        //html on top of phaser scene
        let settingHtml = `<div class="setting-wrapper">
        <div class="setting-child__wrapper audio-wrapper">
            <img class="icon on" src="https://xelestech.com/assets/icons/icon_audio_on.png">
            <img class="icon off" src="https://xelestech.com/assets/icons/icon_audio_off.png">
        </div>
        <div id="inventory-icon" class="setting-child__wrapper ">
            <img class="icon on" src="https://xelestech.com/assets/icons/icon_inventory.png">
        </div>
        <div class="setting-child__wrapper hd-wrapper">
            <img class="icon on" src="https://xelestech.com/assets/icons/icon_hd_on.png">
            <img class="icon off" src="https://xelestech.com/assets/icons/icon_hd_off.png">       
        </div>
        </div>`
        $('body').append(settingHtml);
        $(".audio-wrapper .off").hide();
        $(".audio-wrapper .icon").click(function(){
        if (this.className=== "icon on") {
            that.bgMusic.pause()
            $(".audio-wrapper .on").hide();
            $(".audio-wrapper .off").show();
        } else {
        that.bgMusic.play()
            $(".audio-wrapper .off").hide();
            $(".audio-wrapper .on").show();
        }
        });



        $("#inventory-icon").on("click", function(){
            setTimeout(() => {
                if (true) {
                    const message = {
                        event_id: 'initChangingClothes',
                        wearingList: wearingList
                    };

                    var iFrame = document.getElementById("MyFrame").contentWindow;
                    iFrame.postMessage(message, "https://xelestech.com/townhubiframe/index.html");
                    
                    //isFirstTimeInitClothing = false
                }
               
            }, 2000);

        // let visualItemInventory = new Map([
        //     ["Fur",[{name:"wing",partner:"dahly"},{name:"book",partner:"dahly"}]
        //     ],
        //     ["Eye",[{name:"wing",partner:"dahly"},{name:"book",partner:"dahly"}]],
        //     ["FaceAccesory",[]],
        //     ["Hat",[]],
        //     ["Apparel",[]],
        //     ["LeftHand",[]],
        //     ["RightHand",[]],
        //     ["Spirit",[]],
        //     ])

        // let wearingList = new Map([["Fur",{name:"wing",partner:"",origin:"Black Fur"}],
        //             ["Eyes",{name:"",partner:"",origin:""}],
        //             ["Face Accessories",{name:"",partner:"",origin:""}],
        //             ["Hat",{name:"mushroom1",partner:"Guild Saga",origin:""}],
        //             ["Apparel",{name:"",partner:"",origin:""}],
        //             ["Lef tHand",{name:"",partner:"",origin:""}],
        //             ["Right Hand",{name:"",partner:"",origin:""}],
        //             ["Spirit",{name:"",partner:"",origin:""}],
        //             ["Back Weapon",{name:"",partner:"",origin:""}],
        //             ]);
        //window.updateInventoryWearingList(visualItemInventory,wearingList);
        // window.addEventListener("message", (event) => {
        //     if(event.data.event_id === 'changingClothes'){
        //         if (event.data.attrList.isWear){
        //             console.log("old")
        //         }else{
        //             UnEquip(event.data.attrList.items,event.data.attrList.attrKey,playerLocal,playerLocalFur,wearingList)
        //             strWearingList = JSON.stringify(wearingList, replacer);
        //         }
        //     }
        //     }, false);
        

        $(".inventory-wrapper")[0].classList.remove("hide")
        setTimeout(() => {
        $('.inventory-container')[0].classList.remove('close')
        }, 300);
        })


        $(".hd-wrapper .off").hide();
        $(".hd-wrapper .icon").click(function(){
        if (this.className=== "icon on") {
            that.game.scale.setGameSize(window.innerWidth/1.0,window.innerHeight/1.0)
            that.cameras.main.setZoom(0.4)
            $(".hd-wrapper .on").hide();
            $(".hd-wrapper .off").show();
        } else {
            that.game.scale.setGameSize(window.innerWidth/1.5,window.innerHeight/1.5)
            that.cameras.main.setZoom(0.27)
            $(".hd-wrapper .off").hide();
            $(".hd-wrapper .on").show();
        }
        });

        let infoNetworkHtml = `<div class="info-network">
                                <div id="ui-ping" class="info-chil"></div>
                                <div id="ui-roomSelected" class="info-child"></div>
                                <div id="ui-fps" class="info-chil"></div>
                                <div>`;
        $('body').append(infoNetworkHtml);
        uiRoomSelected = document.getElementById("ui-roomSelected");
        uiPing = document.getElementById("ui-ping");
        uiFPS = document.getElementById("ui-fps");

        let roomHtml = `<div id="ui--room" class="room-wrapper">
                        <div class="room-container">
                        <div class="room-child" data-val="room1" data-name="Room 1"><span class="room-child__name">Room 1</span><div><span class="room-child__client-number">0</span>/<span>${ROOM_LIMIT}</span></div></div>
                        <div class="room-child" data-val="room2" data-name="Room 2"><span class="room-child__name">Room 2</span><div><span class="room-child__client-number">0</span>/<span>${ROOM_LIMIT}</span></div></div>
                        </div>
                        </div>`

        $('body').append(roomHtml);

        let publicChatHtml =  `<div id="ui-publicChat" style="display: block;">
                                <div class="public-chat__wrapper">
                                <div id="ui--public-chat__history" class="public-chat__history">
                                <div></div>
                                </div>
                                <form id="form" action="" class="public-chat__form">
                                <input id="input" class="public-chat__input" autocomplete="off"><button class="public-chat__btn">Send</button>
                                </form>
                                </div>
                                </div>`
        $('body').append(publicChatHtml);

        $('.room-child').on("click", function(){
        selectedRoom = this.getAttribute("data-val");
        selectedRoomName = this.getAttribute("data-name");
        uiRoomSelected.textContent = "Room: " + selectedRoomName;
        document.getElementById("ui--room").style.visibility = "hidden";
        socket.emit('create', selectedRoom);

        if (typeof socket !== "undefined") {
            socket.emit('update', {
            action: "Idle",
            domCharacterName: elementChracterName,
            position: { x:player.x, y: player.y },
            scale: playerLocal.scale,
            userName: userName,
            foxId: 2,
            attribute: strWearingList,
            animState : animState,
            room: selectedRoom,
            item2: ""
            });
            }
            //window.liveKitInit(selectedRoom,userName)
         });
        form = document.getElementById('form');
        input = document.getElementById('input');
        publicChatHistory = document.getElementById('ui--public-chat__history');
        document.getElementById("main-screen").addEventListener("click", canvasEvent);



        socket = io(socketPort);
        socket.on('connect', function () {
            mySelfPlayerModels[socket.id] = {
                gg: "s"
            }
            mySelfPlayerModels[socket.id].model = playerLocal;
        });

        setInterval(function () {
            startTime = Date.now();
            socket.emit('ping');
        }, 2000);
        socket.on('getRoomClients', function (result) {
            for (let i = 0; i < result.length; i++) {
                if (result[i] >= ROOM_LIMIT) {
                    document.getElementsByClassName("room-child")[i].classList.add("disable");
                } else {
                    document.getElementsByClassName("room-child")[i].classList.remove("disable");
                }
                document.getElementsByClassName("room-child__client-number")[i].textContent = result[i];
            }
        })

        socket.on('pong', function () {
            let latency = Date.now() - startTime;

            uiPing.textContent = "Ping:" + parseInt(latency) + "ms";

        })
        socket.on('chat', function (result) {
            const node = document.createElement("li");
            const textnode = document.createTextNode(`${result.message.userName}: ${result.message.msg}`);
            node.appendChild(textnode);
            let li = `<li>${result.message.userName}: ${result.message.msg}</li>`;
            publicChatHistory.appendChild(node);
            publicChatHistory.scrollTop = 999999;

            let character;
            let characterX;
            let characterY;

            if (socket.id === result.id) {
                character = mySelfPlayerModels[result.id];

            } else {
                character = otherPlayerModels[result.id];

            }
            characterX = character.model.x;
            characterY = character.model.y;

            if (typeof character.dom !== "undefined") {

            } else {
                elementBubbleChat = that.add.dom(playerStates[result.id].position.x - 200, characterY).createFromCache('bubbleChatHtml');
                elementBubbleChatArray.push(elementBubbleChat)
                character.dom = elementBubbleChat;
                setTimeout(() => {
                    if (elementBubbleChatArray.length >= 1) {
                        elementBubbleChatArray[0].removeElement();
                        elementBubbleChatArray.splice(0, 1);
                    }
                    delete character.dom;
                }, 1500);
            }




            if (elementBubbleChat.getChildByName()) {
                elementBubbleChat.getChildByName().querySelectorAll('[name="ui--bubble-chat__content"]')[0].innerText = result.message.msg;
            }

        });


        socket.on('update', function (data) {
            playerStates = data;



            for (let [id, state] of Object.entries(playerStates)) {
                if (socket.id === id) {
                    continue;
                }
                if (state.room === selectedRoom) {
                    if (otherPlayerModels[id]) {
                        otherPlayerModels[id].model.play('Idle', true, true)
                        otherPlayerModels[id].modelFur.play('Idle', true, true)

                        let otherModelsData = otherPlayerModels[id];
                        let playerStatesData = playerStates[id];

                        if (!otherModelsData.isLoading) {
                            let model = otherModelsData.model;
                            let modelFur = otherModelsData.modelFur
                            let domCharacterName = otherModelsData.domCharacterName;

                            //if (typeof playerStatesData.action !== "undefined") {
                            if (true) {
                                const newValue = JSON.parse(playerStatesData.attribute, reviver);
                                if (playerStatesData.action == "Cloth Change") {
                                    if(playerStatesData.equip){
                                        Equip(playerStatesData.item,playerStatesData.item2,model,modelFur,newValue)
                                    }else{
                                        UnEquip(playerStatesData.item,playerStatesData.item2,model,modelFur,newValue)
                                    }                                   
                                    // SetAttachment(model, "Front_Hat", null)
                                    // SetAttachment(model, "Front_Hat", state.attribute["Hat"] + "_Front_Hat")
                                    // SetAttachment(model, "Front_Left Hand", state.attribute["Left Hand"] + "_Front_Left Hand")
                                }

                                else if (playerStatesData.scale <= 0) {
                                    model.setScale(-0.5, 0.5)
                                    modelFur.setScale(-0.5, 0.5)
                                    model.setY(playerStatesData.position.y - offY);
                                    model.setX(playerStatesData.position.x + offX);
                                    modelFur.setY(playerStatesData.position.y - offY);
                                    modelFur.setX(playerStatesData.position.x + offX);
                                    model.setAnimation(1, playerStatesData.animState, true, true)
                                    modelFur.setAnimation(1, playerStatesData.animState, true, true)
                                } else {
                                    model.setScale(playerStatesData.scale, 0.5)
                                    modelFur.setScale(playerStatesData.scale, 0.5)
                                    model.setY(playerStatesData.position.y - offY);
                                    model.setX(playerStatesData.position.x - offX);
                                    modelFur.setY(playerStatesData.position.y - offY);
                                    modelFur.setX(playerStatesData.position.x - offX);
                                    model.setAnimation(1, playerStatesData.animState, true, true)
                                    modelFur.setAnimation(1, playerStatesData.animState, true, true)
                                }
                                // if(lastAnimState != playerStatesData.animState){
                                //     lastAnimState = playerStatesData.animState
                                //     model.setAnimation(1,playerStatesData.animState, true,true)
                                //     modelFur.setAnimation(1,playerStatesData.animState, true,true)
                                // }
                                
                                model.setDepth(playerStatesData.position.y)
                                modelFur.setDepth(playerStatesData.position.y - 1)

                                domCharacterName.setX(playerStatesData.position.x + playerPaddingX);
                                domCharacterName.setY(playerStatesData.position.y);

                            }
                        }
                    } else {
                        let storeId = id;

                        otherPlayerModels[storeId] = { isLoading: true, model: null };

                        let remotePlayer = that.add.spine(state.position.x, state.position.y, 'boy', 'idle', true);
                        let remotePlayerFur = that.add.spine(state.position.x, state.position.y, 'boy', 'idle', true);
                        const newValue = JSON.parse(state.attribute, reviver);

                        setAttachmentFull(remotePlayer, remotePlayerFur,newValue)

                        //that.physics.add.existing(player);
                        // that.physics.add.collider(s1, player,()=>collided=true, null, this)
                        remotePlayer.setScale(state.scale);

                        remotePlayer.name = state.username;

                        let elementChracterName2 = that.add.dom(state.position.x + playerPaddingX, state.position.y).createFromCache('nameHtml');
                        elementChracterName2.getChildByName().querySelectorAll('[name="ui--character-name"]')[0].innerText = state.userName

                        otherPlayerModels[storeId].domCharacterName = elementChracterName2;
                        otherPlayerModels[storeId].model = remotePlayer;
                        otherPlayerModels[storeId].modelFur = remotePlayerFur;
                        otherPlayerModels[storeId].isLoading = false;


                    }
                }
            }

            setInterval(() => {
                for (let [id, model, modelFur] of Object.entries(otherPlayerModels)) {
                    if (socket.id === id) {
                        continue;
                    }

                    if (model.isLoading) {
                        continue;
                    }

                    if (!playerStates[id]) {

                        let otherPlayerModel = otherPlayerModels[id].model;
                        let otherPlayerModelFur = otherPlayerModels[id].modelFur;
                        otherPlayerModels[id].model.destroy();
                        otherPlayerModels[id].modelFur.destroy();
                        otherPlayerModels[id].domCharacterName.removeElement();
                        //world.remove(otherPlayerModel);

                        delete otherPlayerModels[id];
                        delete otherPlayerModelFur[id];
                    }
                }

            }, 1000)
        })
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            if (input.value) {
                let param = {
                    userName: userName,
                    msg: input.value,
                    room: selectedRoom
                }

                socket.emit('chat', param);
                input.value = '';
            }

        });


    }


    update(time, delta) {
        var loop = this.sys.game.loop;

        uiFPS.textContent = "FPS:" + parseInt(loop.actualFps);

        let randomNum = Math.floor(Math.random() * 1000);

        // if (musicOn === true && musicAlreadyOn != true) {
        //     console.log("play music")
        //     this.bgMusic = this.sound.add('bgMusic', { volume: 0.5, loop: true });
        //     this.bgMusic.play();
        //     musicAlreadyOn = true
        // }else if(musicOn === false && musicAlreadyOn != true){
        //     console.log("stop music")
        //     //this.bgMusic.pause()
        //     musicAlreadyOn = false
        // }

        playerLocal.depth = player.y
        playerLocalFur.depth = player.y - 1

        switch (animState) {
            case "Idle":
                
                if(wearingList.get("Back Weapon").name == "Demon Skeleton Wings"){
                    playerLocalFur.play('Idle_wing', true, true)
                    playerLocal.play('Idle', true, true)
                    //playerLocal.play('Idle_wing', true, true)
                }else if(wearingList.get("Hat").name == "Epic Shroom w_Dahlys"){
                    playerLocalFur.play('Idle_hat', true, true)
                    playerLocal.play('Idle_hat', true, true)
                }
                else{
                    playerLocalFur.play('Idle', true, true)  
                    playerLocal.play('Idle', true, true)  
                }
                break
            case "Walk":
                
                if(wearingList.get("Back Weapon").name == "Demon Skeleton Wings"){
                    playerLocalFur.play('run_wing', true, true)
                    playerLocal.play('run', true, true)
                    //playerLocal.play('run_wing', true, true)
                }else if(wearingList.get("Hat").name == "Epic Shroom w_Dahlys"){
                    playerLocalFur.play('run_hat', true, true)
                    playerLocal.play('run_hat', true, true)
                }
                else{
                    playerLocalFur.play('run', true, true)
                    playerLocal.play('run', true, true)  
                    //playerLocal.play('run', true, true)
                }
                //playerLocalFur.play('run', true, true)
                break
            case "Toast":
                //playerLocalFur.play('Toast', true, true)
                if(wearingList.get("Back Weapon").name == "Demon Skeleton Wings"){
                    playerLocalFur.play('Toast_wing', true, true)
                    playerLocal.play('Toast', true, true)
                }else if(wearingList.get("Hat").name == "Epic Shroom w_Dahlys"){
                    playerLocalFur.play('Toast_hat', true, true)
                    playerLocal.play('Toast_hat', true, true)
                }
                else{
                    playerLocalFur.play('Toast', true, true)
                    playerLocal.play('Toast', true, true)  
                }
                break
            case "Celebrate":
                
                //playerLocalFur.play('Celebrate', true, true)
                if(wearingList.get("Back Weapon").name == "Demon Skeleton Wings"){
                    playerLocalFur.play('Celebrate_wing', true, true)
                    playerLocal.play('Celebrate', true, true)
                    //playerLocal.play('Celebrate_wing', true, true)
                }else if(wearingList.get("Hat").name == "Epic Shroom w_Dahlys"){
                    playerLocalFur.play('Celebrate_hat', true, true)
                    playerLocal.play('Celebrate_hat', true, true)
                }
                else{
                    playerLocalFur.play('Celebrate', true, true)
                    playerLocal.play('Celebrate', true, true)
                    //playerLocal.play('Celebrate', true, true)  
                }
                break
            case "Hand Wave":
                
                //playerLocalFur.play('Hand Wave', true, true)
                if(wearingList.get("Back Weapon").name == "Demon Skeleton Wings"){
                    playerLocalFur.play('Hand Wave_wing', true, true)
                    playerLocal.play('Hand Wave', true, true)
                    //playerLocal.play('Hand Wave_wing', true, true)
                }else if(wearingList.get("Hat").name == "Epic Shroom w_Dahlys"){
                    playerLocalFur.play('Hand Wave_hat', true, true)
                    playerLocal.play('Hand Wave_hat', true, true)
                }
                else{
                    playerLocalFur.play('Hand Wave', true, true) 
                    playerLocal.play('Hand Wave', true, true) 
                    //playerLocal.play('Hand Wave', true, true)  
                }
                break
            default:
                
                //playerLocalFur.play('Idle', true, true)
                if(wearingList.get("Back Weapon").name == "Demon Skeleton Wings"){
                    playerLocalFur.play('Idle_wing', true, true)
                    playerLocal.play('Idle', true, true)
                    //playerLocalFur.play('Idle_wing', true, true)  
                }else if(wearingList.get("Hat").name == "Epic Shroom w_Dahlys"){
                    playerLocalFur.play('Idle_hat', true, true)
                    playerLocal.play('Idle_hat', true, true)
                }
                else{
                    playerLocalFur.play('Idle', true, true)
                    playerLocal.play('Idle', true, true)  
                    //playerLocal.play('Idle', true, true)  
                }
                break
        }

        if (document.activeElement.tagName !== "INPUT") {
            if (keys.A.isDown) {
                animState = "Walk"
                //playerLocal.play('run', true,true)
                //playerLocalFur.play('run', true,true)
                playerLocal.setScale(-0.5, 0.5)
                playerLocalFur.setScale(-0.5, 0.5)
                player.setVelocityX(-1 * delta);
                playerLocal.setY(player.y - offY);
                playerLocal.setX(player.x + offX);
                playerLocalFur.setY(player.y - offY);
                playerLocalFur.setX(player.x + offX);


                elementChracterName.setX(player.x + playerPaddingX);
                elementChracterName.setY(player.y);

                socket.emit('update', {
                    action: "left",
                    domCharacterName: elementChracterName,
                    position: { x: player.x, y: player.y },
                    scale: playerLocal.scale,
                    userName: userName,
                    foxId: 2,
                    animState: animState,
                    room: selectedRoom
                });


            }
            else if (keys.D.isDown) {

                animState = 'Walk'
                // playerLocal.play('run', true,true)
                // playerLocalFur.play('run', true,true)
                player.setVelocityX(1 * delta);
                playerLocal.setScale(0.5, 0.5)
                playerLocalFur.setScale(0.5, 0.5)
                playerLocal.setY(player.y - offY);
                playerLocal.setX(player.x - offX);
                playerLocalFur.setY(player.y - offY);
                playerLocalFur.setX(player.x - offX);
                elementChracterName.setX(player.x + playerPaddingX);
                elementChracterName.setY(player.y);

                socket.emit('update', {
                    action: "right",
                    domCharacterName: elementChracterName,
                    position: { x: player.x, y: player.y },
                    scale: playerLocal.scale,
                    userName: userName,
                    foxId: 2,
                    animState: animState,
                    room: selectedRoom
                });
            }
            else if (keys.W.isDown) {
                animState = 'Walk'
                // playerLocal.play('run', true,true)
                // playerLocalFur.play('run', true,true)
                player.setVelocityY(-1 * delta);
                if (playerLocal.scale > 0) {
                    playerLocal.setY(player.y - offY);
                    playerLocal.setX(player.x - offX);
                    playerLocalFur.setY(player.y - offY);
                    playerLocalFur.setX(player.x - offX);

                } else {
                    playerLocal.setY(player.y - offY);
                    playerLocal.setX(player.x + offX);
                    playerLocalFur.setY(player.y - offY);
                    playerLocalFur.setX(player.x + offX);

                }
                elementChracterName.setX(player.x + playerPaddingX);
                elementChracterName.setY(player.y);

                socket.emit('update', {
                    action: "up",
                    domCharacterName: elementChracterName,
                    position: { x: player.x, y: player.y },
                    scale: playerLocal.scale,
                    userName: userName,
                    foxId: 2,
                    animState: animState,
                    room: selectedRoom
                });

            }

            else if (keys.S.isDown) {
                animState = 'Walk'
                // playerLocal.play('run', true,true)
                // playerLocalFur.play('run', true,true)
                player.setVelocityY(1 * delta);
                if (playerLocal.scale > 0) {
                    playerLocal.setY(player.y - offY);
                    playerLocal.setX(player.x - offX);
                    playerLocalFur.setY(player.y - offY);
                    playerLocalFur.setX(player.x - offX);

                } else {
                    playerLocal.setY(player.y - offY);
                    playerLocal.setX(player.x + offX);
                    playerLocalFur.setY(player.y - offY);
                    playerLocalFur.setX(player.x + offX);

                }
                elementChracterName.setX(player.x + playerPaddingX);
                elementChracterName.setY(player.y);
                let gg = building;

                socket.emit('update', {
                    action: "down",
                    domCharacterName: elementChracterName,
                    position: { x: player.x, y: player.y },
                    scale: playerLocal.scale,
                    userName: userName,
                    foxId: 2,
                    animState: animState,
                    room: selectedRoom
                });


            }
            else if (Phaser.Input.Keyboard.JustDown(keys.X)) {
                this.talk()
            }
            else if (keys.C.isDown) {
                animState = 'Toast'
                socket.emit('update', {
                    action: "down",
                    domCharacterName: elementChracterName,
                    position: { x: player.x, y: player.y },
                    scale: playerLocal.scale,
                    userName: userName,
                    foxId: 2,
                    animState: animState,
                    room: selectedRoom
                });
            }
            else if (keys.V.isDown) {
                animState = 'Celebrate'
                socket.emit('update', {
                    action: "down",
                    domCharacterName: elementChracterName,
                    position: { x: player.x, y: player.y },
                    scale: playerLocal.scale,
                    userName: userName,
                    foxId: 2,
                    animState: animState,
                    room: selectedRoom
                });
            }
            else if (keys.B.isDown) {
                animState = 'Hand Wave'
                socket.emit('update', {
                    action: "down",
                    domCharacterName: elementChracterName,
                    position: { x: player.x, y: player.y },
                    scale: playerLocal.scale,
                    userName: userName,
                    foxId: 2,
                    animState: animState,
                    room: selectedRoom
                });
            }
            // else if (Phaser.Input.Keyboard.JustDown(keys.P)) {
            //     if (i_cloth == 1) {
            //         SetAttachment(playerLocal, "Front_Hat", "Wreath Blue_Front_Hat")
            //         SetAttachment(playerLocal, "Front_Left Hand", "Beer_Front_Left Hand")
            //         wearingList.set("Hat").origin = "Wreath Blue"
            //         wearingList.set("Left Hand").origin = "Beer"
            //         i_cloth = i_cloth + 1
            //     } else if (i_cloth == 2) {
            //         SetAttachment(playerLocal, "Front_Hat", "Wreath Red_Front_Hat")
            //         SetAttachment(playerLocal, "Front_Left Hand", "Beer_Front_Left Hand")
            //         //attributeListConv["Hat"] = "Wreath Red"
            //         //attributeListConv["Left Hand"] = "Beer"
            //         i_cloth = i_cloth - 1
            //     }
            //     socket.emit('update', {
            //         action: "equip",
            //         domCharacterName: elementChracterName,
            //         position: { x: player.x, y: player.y },
            //         scale: playerLocal.scale,
            //         userName: userName,
            //         foxId: 2,
            //         animState: animState,
            //         room: selectedRoom
            //     });

            //}
            else {
                if (animState != 'Idle') {
                    animState = 'Idle'
                    //playerLocal.play('Idle', true)
                    //playerLocalFur.play('Idle', true)
                    player.setVelocity(0, 0)
                    if (playerLocal.scale > 0) {
                        playerLocal.setY(player.y - offY);
                        playerLocal.setX(player.x - offX);
                        playerLocalFur.setY(player.y - offY);
                        playerLocalFur.setX(player.x - offX);

                    } else {
                        playerLocal.setY(player.y - offY);
                        playerLocal.setX(player.x + offX);
                        playerLocalFur.setY(player.y - offY);
                        playerLocalFur.setX(player.x + offX);
                    }
                    socket.emit('update', {
                        //action: "Idlelo",
                        domCharacterName: elementChracterName,
                        position: { x: player.x, y: player.y },
                        scale: playerLocal.scale,
                        userName: userName,
                        foxId: 2,
                        attribute: strWearingList,
                        animState: animState,
                        room: selectedRoom
                    });
                }





            }

        }
    }

    talk() {
        dialogEvents.emit("wantToTalk");
    }

    createRetroFonts() {
        this.coinValue = 0;
        var config = {
            image: "retroFont",
            width: 8,
            height: 8,
            chars: "012345acx6789:",
            charsPerRow: 9,
            spacing: { x: 0, y: 0 }
        };
        this.cache.bitmapFont.add(
            "retroFont",
            Phaser.GameObjects.RetroFont.Parse(this, config)
        );
        this.dynamicText = this.add.bitmapText(
            5,
            5,
            "retroFont",
            "cx" + this.coinValue
        );
        this.dynamicText.setScrollFactor(0);
    }

}